'use strict';

var $$ = $$ || {};

$$.Config = {
	addCartUrl: '/.ajax/add2Cart.php',
	removeCartUrl: '/.ajax/deleteInCart.php',
	removeAllCartUrl: '/.ajax/clearCart.php',
	updateCartUrl: '/.ajax/updateCart.php',
	deleteInCart: '/.ajax/deleteInCart.php',
	addCoupon: '/.ajax/addCoupon.php',
	confirmCity: '/.ajax/confirm_city.php',
	changeDelivery: '/.ajax/getListDelivery.php',
	search: '/.ajax/search.php'
};
"use strict";

var $$ = $$ || {};

$$.Simulation = $$.Simulation || {};

/**
 * Не нужно использовать этот класс напрямую. Нужно использовать $$.Simulation.Spring.
 */
$$.Simulation.SpringSimulator = function () {
	var self = this;

	this._springs = [];
	this._lastTime = +new Date();

	setInterval(function () {
		var now = +new Date();
		var time = (now - self._lastTime) / 1000;
		var dt = 0.01;

		if (time > 0.2) {
			// Если жс работает слишком медленно, замедлить симуляцию.
			time = 0.2;
		}

		var i,
		    ni = self._springs.length,
		    spring,
		    dampings = [],
		    distance,
		    newDistance,
		    force,
		    newVelocity,
		    targetVelocityLimit,
		    velocityLimit,
		    positionLimits;

		for (i = 0; i < ni; i++) {
			spring = self._springs[i];
			dampings.push(2 * Math.sqrt(spring._rigidness) * spring._damping);
		}

		while (time > 0.000001) {
			for (i = 0; i < ni; i++) {
				spring = self._springs[i];

				if (spring._frozen) {
					continue;
				}

				distance = spring._target - spring._position;

				force = (distance >= 0 ? 1 : -1) * Math.pow(Math.abs(distance), spring._forcePower) * spring._rigidness - (spring._velocity >= 0 ? 1 : -1) * Math.abs(spring._velocity) * dampings[i];

				newVelocity = spring._velocity + force * dt;

				velocityLimit = spring._velocityLimit;
				targetVelocityLimit = spring._targetVelocityLimit;

				if (targetVelocityLimit !== null) {
					targetVelocityLimit *= Math.pow(spring._targetVelocityLimitPower, Math.abs(distance));

					if (velocityLimit === null || targetVelocityLimit < velocityLimit) {
						velocityLimit = targetVelocityLimit;
					}
				}

				if (velocityLimit !== null && Math.abs(newVelocity) > velocityLimit) {
					newVelocity = (newVelocity >= 0 ? 1 : -1) * velocityLimit;
				}

				spring._position += newVelocity * dt;
				spring._velocity = newVelocity;

				if (spring._stopAtTarget) {
					newDistance = spring._target - spring._position;

					if (distance > 0 && newDistance <= 0 || distance < 0 && newDistance >= 0) {
						spring._position = spring._target;
						spring._velocity = 0;
						continue;
					}
				}

				if (spring._positionLimits !== null) {
					positionLimits = spring._positionLimits;

					if (spring._position < positionLimits[0]) {
						spring._position = positionLimits[0];
						spring._velocity = 0;
					} else if (spring._position > positionLimits[1]) {
						spring._position = positionLimits[1];
						spring._velocity = 0;
					}
				}
			}

			time -= dt;
		}

		self._lastTime = now;

		for (i = 0; i < ni; i++) {
			spring = self._springs[i];

			if (spring == null) {
				continue;
			}

			if (!spring._frozen && spring._step) {
				spring._step.call();
			}
		}
	}, 16);
};

$$.Simulation.SpringSimulator.prototype = {
	addSpring: function addSpring(spring) {
		this._springs.push(spring);
	},

	deleteSpring: function deleteSpring(spring) {
		var i = _.indexOf(this._springs, spring);

		if (i != -1) {
			this._springs.splice(i, 1);
		}
	}
};

// Создать один "глобальный" экземпляр.

$$.Simulation.__springSimulator = new $$.Simulation.SpringSimulator();
'use strict';

var $$ = $$ || {};

$$.Simulation = $$.Simulation || {};

/**
 * @constructor
 */
$$.Simulation.Spring = function (options) {
	options = _.extend({
		frozen: false,
		position: 0,
		positionLimits: null,
		target: 0,
		targetLimits: null,
		velocity: 0,
		velocityLimit: null,
		rigidness: 1,
		damping: 1,
		forcePower: 1,
		targetVelocityLimit: null,
		targetVelocityLimitPower: 1.25,
		stopAtTarget: false,
		step: null
	}, options || {});

	this._frozen = options.frozen;
	this._position = options.position;
	this._positionLimits = options.positionLimits;
	this._target = options.target;
	this._targetLimits = options.targetLimits;
	this._velocity = options.velocity;
	this._velocityLimit = options.velocityLimit;
	this._rigidness = options.rigidness;
	this._damping = options.damping;
	this._forcePower = options.forcePower;
	this._targetVelocityLimit = options.targetVelocityLimit;
	this._targetVelocityLimitPower = options.targetVelocityLimitPower;
	this._stopAtTarget = options.stopAtTarget;
	this._step = null;

	if (options.step) {
		this.step(options.step);
	}

	this._applyTargetLimits();

	$$.Simulation.__springSimulator.addSpring(this);
};

$$.Simulation.Spring.prototype = {
	_applyTargetLimits: function _applyTargetLimits() {
		if (this._targetLimits === null) {
			return;
		}

		if (this._target < this._targetLimits[0]) {
			this._target = this._targetLimits[0];
		} else if (this._target > this._targetLimits[1]) {
			this._target = this._targetLimits[1];
		}
	},

	destroy: function destroy() {
		this._step = null;
		$$.Simulation.__springSimulator.deleteSpring(this);
	},

	moveTarget: function moveTarget(delta) {
		this._target += delta;
		this._applyTargetLimits();
	},

	step: function step(callback) {
		this._step = _.bind(callback, this);
	},

	target: function target(value) {
		if (arguments.length == 0) {
			return this._target;
		}

		this._target = value;
		this._applyTargetLimits();
	},

	targetLimits: function targetLimits(value) {
		if (arguments.length == 0) {
			return this._targetLimits;
		}

		this._targetLimits = value;
		this._applyTargetLimits();
	}
};

// Создать методы-аксессоры.

_.each(['frozen', 'position', 'positionLimits', 'velocity', 'velocityLimit', 'rigidness', 'damping', 'forcePower', 'targetVelocityLimit', 'targetVelocityLimitPower', 'stopAtTarget'], function (k) {
	$$.Simulation.Spring.prototype[k] = function (value) {
		if (arguments.length == 0) {
			return this['_' + k];
		}

		this['_' + k] = value;
	};
});
'use strict';

var $$ = $$ || {};

$$.extend = function (Child, Parent) {
	var F = function F() {};
	F.prototype = Parent.prototype;
	Child.prototype = new F();
	Child.prototype.constructor = Child;
	Child.superclass = Parent.prototype;
};

$$.trim = function (str, charlist) {
	charlist = !charlist ? ' \\s\xA0' : charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '\$1');
	var re = new RegExp('^[' + charlist + ']+|[' + charlist + ']+$', 'g');
	return str.replace(re, '');
};

$$.parseUrlParams = function (url) {
	var url = url || location.href;
	var searchParam = {};
	var regExpParams = /\?{1}.+/;

	if (regExpParams.test(url)) {
		url = url.replace(regExpParams, '');

		var urlParams = location.search.replace('?', '');
		urlParams = urlParams.split('&');

		_.each(urlParams, function (item, index, list) {
			var param = item.split('=');
			searchParam[param[0]] = param[1];
		});
	}
	return searchParam;
};

$$.clamp = function (value, min, max) {
	return Math.min(max, Math.max(min, value));
};

$$.getRandomInt = function (min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

$$.Transitions = {
	linear: function linear(t) {
		return t;
	},

	quadIn: function quadIn(t) {
		return t * t;
	},

	quadInOut: function quadInOut(t) {
		t *= 2;

		if (t < 1) {
			return 0.5 * t * t;
		}

		return -0.5 * ((t - 1) * (t - 3) - 1);
	},

	quadOut: function quadOut(t) {
		return -t * (t - 2);
	},

	sineIn: function sineIn(t) {
		return 1 - Math.cos(t * Math.PI * 0.5);
	},

	sineInOut: function sineInOut(t) {
		return 0.5 - 0.5 * Math.cos(t * Math.PI);
	},

	sineOut: function sineOut(t) {
		return Math.sin(t * Math.PI * 0.5);
	}
};

$$.makeVideoPlayerHtml = function (videoType, videoId, width, height) {
	if (videoType == 'youtube') {
		return '<iframe class="youtube-player" type="text/html"' + ' width="' + width + '" height="' + height + '" src="' + '//www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&amp;controls=0&amp;showinfo=0' + '" frameborder="0" wmode="opaque" autoplay="true"></iframe>';
	} else if (videoType == 'vimeo') {
		return '<iframe wmode="opaque" width="' + width + '" height="' + height + '" src="' + '//player.vimeo.com/video/' + videoId + '?autoplay=1' + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
	}

	return '';
};
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.AjaxSearch = (function () {
	function AjaxSearch(root) {
		var _this = this;

		_classCallCheck(this, AjaxSearch);

		this.root = root;

		this._cacheNodes();
		this._bindEvents();

		this.waitAjaxRequest = false;

		this._debouncedAjaxRequest = _.debounce(function (value) {
			_this._ajaxRequest(value);
		}, 300);
	}

	_createClass(AjaxSearch, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				input: this.root.find('.js-menu-search'),
				result: this.root.find('.js-search-results')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this2 = this;

			this.nodes.input.on('focusin', function (event) {
				$(event.currentTarget).addClass('focus');
			}).on('focusout', function (event) {
				setTimeout(function () {
					$(event.currentTarget).removeClass('focus');
				}, 200);
			}).on('keyup', function (event) {
				var input = $(event.currentTarget);
				var value = input.val();

				if (value.length < 3 || _this2.waitAjaxRequest) {
					return;
				}

				_this2._debouncedAjaxRequest(value);
			});
		}
	}, {
		key: '_ajaxRequest',
		value: function _ajaxRequest(value) {
			var _this3 = this;

			var data = {
				value: value
			};

			this.waitAjaxRequest = true;

			$.ajax({
				url: $$.Config.search,
				method: 'POST',
				data: data,
				success: function success(response) {
					response = $.parseJSON(response);

					if (response.success) {
						_this3.nodes.result.html(response.success);
					} else {
						_this3.nodes.result.html(response.error);
					}
				},
				complete: function complete() {
					_this3.waitAjaxRequest = false;
				}
			});
		}
	}]);

	return AjaxSearch;
})();
'use strict';

var initAnalytics = function initAnalytics() {
	$$.yandexMetrika = new $$.YandexMetrika(window.yaCounter35097645);
	$$.googleAnalytics = new $$.GoogleAnalytics();
	$$.FacebookPixel = new $$.FacebookPixel();
	/**
  * Простые цели
  */

	// Скачать прайс-лист монтажных работ
	$('.js-click-installation-download-price').on('click', function () {
		$$.yandexMetrika.reachGoal('installation-download-price');
		$$.googleAnalytics.reachPage('/virtual/installation-download-price');
	});

	// Скачать прайс-листы со страницы плайс листов
	$('.js-click-prices-download-price').on('click', function () {
		$$.yandexMetrika.reachGoal('prices-download-price');
		$$.googleAnalytics.reachPage('/virtual/prices-download-price');
	});

	// Обратная связь через email
	$('.js-click-email-feedback').on('click', function () {
		$$.yandexMetrika.reachGoal('email-feedback');
		$$.googleAnalytics.reachPage('/virtual/email-feedback');
	});

	/**
  * Состовные цели
  */

	var instalationForms = $('.js-click-installation-forms form');

	// Заказ звонка со страницы “монтаж” (первое взаимодействие)
	instalationForms.eq(0).one('change', 'input', function () {
		$$.yandexMetrika.reachGoal('installation-order-call-input');
		$$.googleAnalytics.reachPage('/virtual/installation-order-call-input');
	});

	// Отправка формы (Подробный расчёт монтажа — бесплатно!)
	// instalationForms.eq(0).one('click', '[type="submit"]', () => {
	instalationForms.eq(0).one('tabFormSubmit', function () {
		$$.yandexMetrika.reachGoal('installation-order-call-submit');
		$$.googleAnalytics.reachPage('/virtual/installation-order-call-submit');
	});

	// Обратная связь
	instalationForms.eq(1).one('change', 'input', function () {
		$$.yandexMetrika.reachGoal('installation-feedback-input');
		$$.googleAnalytics.reachPage('/virtual/installation-feedback-input');
	});

	// Отправка формы Обратная связь (форма после расчета монтажа)
	//	instalationForms.eq(1).one('click', '[type="submit"]', () => {
	instalationForms.eq(1).one('tabFormSubmit', function () {
		$$.yandexMetrika.reachGoal('installation-order-call-submit');
		$$.googleAnalytics.reachPage('/virtual/installation-order-call-submit');
	});

	var headerForms = $('.js-header-wrapper .call-me form');

	// Клик по телефону
	$('.js-upper-header .js-feedback').on('click', function () {
		$$.yandexMetrika.reachGoal('header-phone-click');
		$$.googleAnalytics.reachPage('/virtual/header-phone-click');
	});

	// Заказ звонка из хеадера (первое взаимодействие)
	headerForms.eq(0).one('change', 'input', function () {
		$$.yandexMetrika.reachGoal('header-order-call-input');
		$$.googleAnalytics.reachPage('/virtual/header-order-call-input');
	});

	// Заказ звонка из хеадера (отправка)
	//	headerForms.eq(0).one('click', '[type="submit"]', () => {
	headerForms.eq(0).one('headerFormSubmit', function () {
		$$.yandexMetrika.reachGoal('header-order-call-submit');
		$$.googleAnalytics.reachPage('/virtual/header-order-call-submit');
	});

	// Обратная связь из хеадера (первое взаимодействие)
	headerForms.eq(1).one('change', 'input', function () {
		$$.yandexMetrika.reachGoal('header-feedback-input');
		$$.googleAnalytics.reachPage('/virtual/header-feedback-input');
	});

	// Обратная связь из хеадера (отправка)
	//	headerForms.eq(1).one('click', '[type="submit"]', () => {
	headerForms.eq(1).one('headerFormSubmit', function () {
		$$.yandexMetrika.reachGoal('header-feedback-submit');
		$$.googleAnalytics.reachPage('/virtual/header-feedback-submit');
	});

	var pricesForms = $('.js-partner-form form');

	// Заказ звонка прайс листы (первое взаимодействие)
	pricesForms.one('change', 'input', function () {
		$$.yandexMetrika.reachGoal('prices-order-call-input');
		$$.googleAnalytics.reachPage('/virtual/prices-order-call-input');
	});

	// Заказ звонка прайс листы (отправка)
	//	pricesForms.one('click', '[type="submit"]', () => {
	pricesForms.one('partnerFormSubmit', function () {
		$$.yandexMetrika.reachGoal('prices-order-call-submit');
		$$.googleAnalytics.reachPage('/virtual/prices-order-call-submit');
	});

	// Оформление заказа
	$('.js-cart .js-order').on('click', function () {
		$$.yandexMetrika.reachGoal('cart-order-click');
		$$.googleAnalytics.reachPage('/virtual/cart-order-click');
	});

	// Далее заказа
	$('.js-delivery .js-submit').on('click', function () {
		$$.yandexMetrika.reachGoal('delivery-next-click');
		$$.googleAnalytics.reachPage('/virtual/delivery-next-click');
	});

	// Далее оплаты
	$('.js-pay-page .js-pay-next').on('click', function () {
		$$.yandexMetrika.reachGoal('pay-next-click');
		$$.googleAnalytics.reachPage('/virtual/pay-next-click');
	});

	// Оформить последней страницы
	$('.js-order-finish .js-order-finish-submit').on('click', function () {
		var data = {
			value: parseFloat($('.js-form input[name=ORDER_PRICE]').val()),
			currency: 'RUB'
		};

		$$.FacebookPixel.reachGoal('Purchase', data);
		$$.yandexMetrika.reachGoal('order-finish-submit');
		$$.googleAnalytics.reachPage('/virtual/order-finish-submit');
	});

	//  Узнать как заказать
	$('.card .js-feedback').on('click', function () {
		$.get('/.ajax/getSessionParam.php?howToOrder=true').done(function (data) {
			if (data === 'true') {
				$$.yandexMetrika.reachGoal('how-to-order-click');
				$$.googleAnalytics.reachPage('/virtual/how-to-order-click');
			}
		});
	});

	//  Регистрация
	$('.js-click-header-registration').on('click', function (event) {
		event.preventDefault();

		$$.yandexMetrika.reachGoal('do-registration-click');
		$$.googleAnalytics.reachPage('/virtual/do-registration-click');

		setTimeout("document.location.href='" + $(event.currentTarget).attr('href') + "'", 100);
	});

	//  Регистрация форма

	var registrationForm = $('.js-registration-page form');

	registrationForm.one('change', 'input', function () {
		$$.yandexMetrika.reachGoal('do-registration-input');
		$$.googleAnalytics.reachPage('/virtual/do-registration-input');
	});

	// Форма регистрации (отправка)
	//	registrationForm.one('click', '[type="submit"]', () => {
	registrationForm.one('registrationFormSubmit', function () {
		$$.yandexMetrika.reachGoal('do-registration-submit');
		$$.googleAnalytics.reachPage('/virtual/do-registration-submit');
	});

	//  Регистрация на событие форма
	var registrationEventForm = $('.js-registration-event-form');

	registrationEventForm.one('change', 'input', function () {
		$$.yandexMetrika.reachGoal('do-registration-event-input');
		$$.googleAnalytics.reachPage('/virtual/do-registration-event-input');
	});

	// Форма регистрации на событие (отправка)
	//	registrationEventForm.one('click', '[type="submit"]', () => {
	registrationEventForm.one('registrationEventFormSubmit', function () {
		$$.yandexMetrika.reachGoal('do-registration-event-submit');
		$$.googleAnalytics.reachPage('/virtual/do-registration-event-submit');
	});

	// Клик на кнопку добавить в корзину

	$('.js-add-to-cart').on('click', function () {
		$$.yandexMetrika.reachGoal('add-to-cart');
		$$.googleAnalytics.reachPage('/virtual/add-to-cart');
		$$.FacebookPixel.reachGoal('AddToCart');
	});

	//ПРОМО САЙТ
	//клик на кнопку "заказать"

	$('.b-promo-cam .js-open-popup[data-popup=order]').on('click', function () {
		$$.yandexMetrika.reachGoal('order-on-landing');
		$$.googleAnalytics.reachPage('/virtual/order-on-landing');
	});

	//клик на кнопку "купить" в попапе покупки

	$('.b-promo-cam .js-popup-content[data-popup-content-name=order] .g-button').on('click', function () {
		$$.yandexMetrika.reachGoal('buy-on-landing');
		$$.googleAnalytics.reachPage('/virtual/buy-on-landing');
	});

	//клик на кнопку "заказать звонок"

	$('.b-promo-cam [data-popup=call-me]').on('click', function () {
		$$.yandexMetrika.reachGoal('call-me-on-landing');
		$$.googleAnalytics.reachPage('/virtual/call-me-on-landing');
	});

	//клик на кнопку "отправить" в попапе заказа звонка

	//	$('.b-promo-cam .js-partner-form .submit').on('click', () => {
	$('.b-promo-cam .js-partner-form').on('partnerFormSubmit', function () {
		$$.yandexMetrika.reachGoal('send-call-request-on-landing');
		$$.googleAnalytics.reachPage('/virtual/send-call-request-on-landing');
	});
};
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.Anchors = (function () {
	function Anchors(root) {
		_classCallCheck(this, Anchors);

		this.root = root;

		this.sectionsPosition = [];

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(Anchors, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				anchors: this.root.find('.js-anchor'),
				sections: this.root.find('.js-anchor-section')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.anchors.on('click', function (event) {
				var anchor = $(event.currentTarget);

				$('html, body').animate({
					scrollTop: $(_this.nodes.sections.get(anchor.index())).position().top - 97
				}, 200);
			});

			$$.window.on('scroll', _.debounce(function (event) {
				var scrollTop = event.currentTarget.scrollY;

				_.forEachRight(_this.sectionsPosition, function (position, index) {
					if (position >= scrollTop) {
						_this.nodes.anchors.removeClass('active');
						$(_this.nodes.anchors.get(index)).addClass('active');
					}
				});
			}, 100, {
				leading: true
			})).on('resize', function () {
				return _this._sectionsPosition();
			}).trigger('scroll');
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this._sectionsPosition();
		}
	}, {
		key: '_sectionsPosition',
		value: function _sectionsPosition() {
			var _this2 = this;

			this.nodes.sections.each(function (index, section) {
				_this2.sectionsPosition[index] = $(section).position().top + $$.windowHeight / 2;
			});
		}
	}]);

	return Anchors;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.Auth = (function () {
	function Auth(root) {
		_classCallCheck(this, Auth);

		this.root = root;

		this.formStates = {
			closed: 'g-icon-eye-closed',
			opened: 'g-icon-eye-opened'
		};

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(Auth, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				eye: this.root.find('.js-eye'),
				passwordInput: this.root.find('.js-password-input'),
				enter: this.root.find('.js-enter'),
				profile: this.root.find('.js-profile')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.eye.on('click', function () {
				_this._togglePasswordInput();
			});

			this.root.validate({
				submitHandler: function submitHandler(form) {
					form = $(form);

					$.ajax({
						url: form.attr('action'),
						method: form.attr('method'),
						data: form.serialize(),
						success: function success(response) {
							response = $.parseJSON(response);

							if (response.errors) {
								_.each(response.errors, function (value, key) {
									var input = form.find('input[name="' + key + '"]').addClass('error');
									var error = $('<label class="error">' + value + '</label>');

									error.insertAfter(input);
								});
							} else if (response.redirect) {
								window.location.href = response.redirect;
							}
						}
					});
				}
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			var parameters = $$.parseUrlParams(location.href);
			var auth = parameters.auth;

			if ('auth' in parameters && auth.toString() === 'true') {
				this.nodes.enter.addClass('hidden');
				this.nodes.profile.removeClass('hidden');
			}
		}
	}, {
		key: '_togglePasswordInput',
		value: function _togglePasswordInput() {
			if (this.nodes.eye.hasClass(this.formStates.opened)) {
				this.nodes.eye.removeClass(this.formStates.opened);
				this.nodes.eye.addClass(this.formStates.closed);
				this.nodes.passwordInput.attr('type', 'password');
			} else if (this.nodes.eye.hasClass(this.formStates.closed)) {
				this.nodes.eye.removeClass(this.formStates.closed);
				this.nodes.eye.addClass(this.formStates.opened);
				this.nodes.passwordInput.attr('type', 'text');
			}
		}
	}]);

	return Auth;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.BannerSlider = (function () {
	function BannerSlider(root, options) {
		_classCallCheck(this, BannerSlider);

		this.root = root;

		this.options = {
			scrollStep: 400,
			duration: 300,
			menuWidth: 240
		};

		_.assign(this.options, options);

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(BannerSlider, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				inner: this.root.find('.js-inner'),
				itemsWrapper: this.root.find('.js-items'),
				items: this.root.find('.js-item'),
				backwardButton: this.root.find('.js-backward-button'),
				forwardButton: this.root.find('.js-forward-button'),
				pageWrapper: this.root.find('.js-pages'),
				pages: this.root.find('.js-page')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.backwardButton.on('click', function () {
				_this._checkoutSlide(_this.currentSlide - 1);
			});

			this.nodes.forwardButton.on('click', function () {
				_this._checkoutSlide(_this.currentSlide + 1);
			});

			this.nodes.pages.on('click', function (event) {
				var slideNumber = $(event.target).index();
				var scrollStep = 0;

				if (slideNumber > _this.currentSlide) {
					scrollStep = _this.scrollStep;
				} else if (slideNumber < _this.currentSlide) {
					scrollStep = -_this.scrollStep;
				}

				_this._checkoutSlide(slideNumber);
			});

			$$.window.on('resize', function () {
				_.defer(function () {
					var slideWidth = $$.windowWidth - _this.options.menuWidth;
					var slidesCount = _this.nodes.items.length;

					_this.nodes.items.css({ width: slideWidth });
					_this.nodes.itemsWrapper.css({ width: slideWidth * slidesCount });
					_this.scrollStep = slideWidth;
					_this.nodes.inner.scrollLeft(slideWidth * _this.currentSlide);
				});
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			var slideWidth = this.nodes.inner.width();

			this.currentSlide = 0;
			this.isAnimating = false;

			this.nodes.items.css({ width: slideWidth });
			this.nodes.itemsWrapper.css({ width: slideWidth * this.nodes.items.length });
			this.scrollStep = this.nodes.items.first().width();
			this.rightLimit = this.nodes.itemsWrapper.width();
		}
	}, {
		key: '_checkoutSlide',
		value: function _checkoutSlide(slideNumber) {
			var _this2 = this;

			if (this.isAnimating) {
				return;
			}

			if (slideNumber < 0) {
				this._limitScroll(false);
				return;
			} else if (slideNumber >= this.nodes.items.length) {
				this._limitScroll(true);
				return;
			}

			this.isAnimating = true;
			this.nodes.pages.eq(this.currentSlide).removeClass('active');
			this.currentSlide = slideNumber;
			this.nodes.pages.eq(this.currentSlide).addClass('active');

			this.nodes.inner.animate({
				scrollLeft: slideNumber * this.scrollStep
			}, this.options.duration, 'swing', function () {
				_this2.isAnimating = false;
			});
		}
	}, {
		key: '_limitScroll',
		value: function _limitScroll(isToStart) {
			if (isToStart) {
				this._goToStart();
			} else {
				this._goToEnd();
			}
		}
	}, {
		key: '_goToEnd',
		value: function _goToEnd() {
			var _this3 = this;

			var slideItem = this.nodes.items.last().clone();
			var slideWidth = slideItem.width();
			var containerWidth = this.nodes.itemsWrapper.width();

			this.nodes.itemsWrapper.prepend(slideItem);
			this.nodes.itemsWrapper.width(containerWidth + slideItem.width());

			this.nodes.pages.eq(this.currentSlide).removeClass('active');
			this.currentSlide = this.nodes.pages.length - 1;
			this.nodes.pages.eq(this.currentSlide).addClass('active');

			this.nodes.inner.scrollLeft(slideWidth);

			this.nodes.inner.animate({
				scrollLeft: 0
			}, this.options.duration, 'swing', function () {
				_this3.nodes.inner.scrollLeft((_this3.nodes.items.length - 1) * slideWidth);
				slideItem.remove();
				_this3.nodes.itemsWrapper.width(containerWidth);
			});
		}
	}, {
		key: '_goToStart',
		value: function _goToStart() {
			var _this4 = this;

			var slideItem = this.nodes.items.first().clone();
			var containerWidth = this.nodes.itemsWrapper.width();

			this.nodes.itemsWrapper.append(slideItem);
			this.nodes.itemsWrapper.width(containerWidth + slideItem.width());

			this.nodes.pages.eq(this.currentSlide).removeClass('active');
			this.currentSlide = 0;
			this.nodes.pages.eq(this.currentSlide).addClass('active');

			this.nodes.inner.animate({
				scrollLeft: this.nodes.items.length * this.scrollStep
			}, this.options.duration, 'swing', function () {
				_this4.nodes.inner.scrollLeft(0);
				slideItem.remove();
				_this4.nodes.itemsWrapper.width(containerWidth);
			});
		}
	}]);

	return BannerSlider;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.CardPage = (function () {
	function CardPage(root) {
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, CardPage);

		var defaultOptions = {};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(CardPage, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				goodsCount: this.root.find('.js-count-goods'),
				addToCart: this.root.find('.js-add-to-cart'),
				cardImages: this.root.find('.js-card-images'),
				goodsSet: this.root.find('.js-set-goods'),
				galleryModal: this.root.find('.js-gallery-modal')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.galleryModal.on('hidden.bs.modal', function (event) {
				var modal = $(event.currentTarget);

				modal.find('.modal-body').html('');
			});

			this.nodes.cardImages.on('click', '.item', function (event) {
				"use strict";

				event.preventDefault();

				var item = $(event.currentTarget);

				item.addClass('active');
				item.siblings().removeClass('active');

				if (item.hasClass('video')) {
					_this._openModal().find('.modal-body').html('' + $$.makeVideoPlayerHtml(item.data('videoType'), item.data('videoId'), '100%', '342px'));
				} else {
					_this.nodes.cardImages.find('.big-images .image').html('<img src="' + item.data('original') + '" alt="" />');
				}
			});

			this.nodes.cardImages.on('click', '.big-images .image, .g-icon-zoom', function (event) {
				"use strict";
				event.preventDefault();

				var item = $(event.currentTarget);

				var images = _this.nodes.cardImages.find('.small-images .item:not(.video)');
				var items = '';
				images.each(function (index, element) {
					var originalImage = $(element).data('original');
					var description = $(element).find('img').attr('alt');
					var descriptionTemplate = '';

					if (description.length !== 0) {
						descriptionTemplate = '<p class="block-description show js-description">' + description + '</p>';
					} else {
						descriptionTemplate = '';
					}

					items += '<div class="item js-item">\n\t\t\t\t\t\t\t\t<div class="image-wrapper">\n\t\t\t\t\t\t\t\t\t<img class="image" src="' + originalImage + '" alt="">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t' + descriptionTemplate + '\n                            </div>';
				});

				var sliderTemplate = '\n\t\t\t<div class="b-content-slider js-content-slider">\n                <div class="counter-wrapper">\n                    <span class="counter">\n                        <span class="js-current-slide">1</span>/<span class="js-count-slides">1</span>\n                    </span>\n                </div>\n                <div class="outer">\n                    <div class="arrow-left js-backward">\n                        <i class="g-icon g-icon-big-arrow-left icon"></i>\n                    </div>\n                    <div class="arrow-right js-forward">\n                        <i class="g-icon g-icon-big-arrow-right icon"></i>\n                    </div>\n                    <div class="wrapper">\n                        <div class="items js-items">\n                            ' + items + '\n                        </div>\n                    </div>\n                </div>\n            </div>\n\t\t\t';

				_this._openModal().find('.modal-body').html(sliderTemplate);

				new $$.ContentSlider(_this.nodes.galleryModal.find('.js-content-slider'));
			});

			$$.window.on('resize', function () {
				"use strict";
				_this._updateGoodsSet();
			});

			$$.window.resize();
		}
	}, {
		key: '_updateGoodsSet',
		value: function _updateGoodsSet() {
			"use strict";
			var cards = this.nodes.goodsSet.find('.row.cards').children();
			var goodsSetWidth = this.nodes.goodsSet.width();

			var cardsWidth = cards.outerWidth(true);

			var cardsInserted = parseInt(goodsSetWidth / cardsWidth);

			cards.find('.icon-plus.right').removeClass('hide');
			cards.find('.icon-plus.top').removeClass('show');
			cards.find('.icon-equal').removeClass('top, left');
			cards.find('.icon-equal').addClass('left');

			if (cardsInserted < cards.length) {
				if (cards.length % cardsInserted === 1) {
					cards.filter(':nth-child(' + cardsInserted + 'n)').find('.icon-plus.right').addClass('hide');
					cards.filter(':nth-child(' + cardsInserted + 'n + 1)').find('.icon-equal').removeClass('top, left');
					cards.filter(':nth-child(' + cardsInserted + 'n + 1)').find('.icon-equal').addClass('top');
				} else {
					cards.filter(':nth-child(' + cardsInserted + 'n)').find('.icon-plus.right').addClass('hide');
					cards.filter(':nth-child(' + cardsInserted + 'n + 1)').find('.icon-plus.top').addClass('show');
					cards.eq(0).find('.icon-plus.top').removeClass('show');
				}
			}
		}
	}, {
		key: '_openModal',
		value: function _openModal() {
			"use strict";

			return this.nodes.galleryModal.modal('show');
		}
	}, {
		key: '_initGallery',
		value: function _initGallery() {
			"use strict";
		}
	}, {
		key: '_closeModal',
		value: function _closeModal() {
			"use strict";
			return this.nodes.galleryModal.modal('hide');
		}
	}, {
		key: '_destroyGallery',
		value: function _destroyGallery() {
			"use strict";
		}
	}, {
		key: '_ready',
		value: function _ready() {
			"use strict";
		}
	}]);

	return CardPage;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.Cart = (function () {
	function Cart(root) {
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, Cart);

		var defaultOptions = {
			url: '/' // todo action url
		};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.state = 0;

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(Cart, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				cardsContainer: this.root.find('.cards'),
				cards: this.root.find('.js-card'),

				code: this.root.find('.js-code'),
				submitButton: this.root.find('.js-submit'),

				summary: this.root.find('.b-summary'),
				finish: this.root.find('.b-cart-finish'),

				codeContaiter: this.root.find('.js-input-code'),
				invalidMessage: this.root.find('.js-invalid'),
				discountMessage: this.root.find('.js-discount'),
				closeInvalidButton: this.root.find('.js-close-invelid'),

				cleanButton: this.root.find('.js-clean'),
				offerButton: this.root.find('.js-offer')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.submitButton.on('click', function () {
				var data = {
					action: "code",
					code: _this.nodes.code.val()
				};

				$.ajax({
					url: $$.Config.addCoupon,
					method: 'POST',
					data: data,
					success: function success(response) {
						response = $.parseJSON(response);
						if (response.APPLY_COUPON === 'N') {
							_this.nodes.invalidMessage.show();
							_this.nodes.discountMessage.hide();
							_this.nodes.codeContaiter.hide();
						} else {
							_this.nodes.invalidMessage.hide();
							_this.nodes.discountMessage.show();
							_this.nodes.discountMessage.find('.price').text(response.COUPON_DISCOUNT);
							$('.js-sum-all').text(response.SUM_ALL);
							_this.nodes.codeContaiter.hide();
						}
					}
				});
			});

			this.nodes.cleanButton.on('click', function () {
				var data = {
					action: "clean"
				};

				$.ajax({
					url: $$.Config.removeAllCartUrl,
					method: 'POST',
					data: data,
					success: function success(response) {
						response = $.parseJSON(response);

						if (response.success) {
							$$.Noty['successMessage'](response.success);

							$('.js-sum-all').text(response.SUM);
							$('.js-count-all').text(response.amount);
							$('.js-count-text-all').text(response.text_amount);

							if (!response.amount) {
								_this._clearCart();
							}
						} else {
							$$.Noty['errorMessage'](response.error);
						}
					}
				});
			});

			this.nodes.offerButton.on('click', function () {
				var data = {
					action: "offer"
				};

				$.ajax({
					url: _this.options.url,
					method: 'GET',
					data: data,
					success: function success(response) {
						// todo: proceed response
					}
				});
			});

			this.nodes.closeInvalidButton.on('click', function () {
				_this.nodes.invalidMessage.hide();
				_this.nodes.discountMessage.hide();

				_this.nodes.codeContaiter.show();
			});

			this.nodes.cards.on('click', '.js-remove', function (event) {
				var card = $(event.target).closest('.js-card');

				var data = {
					action: "delete",
					id: card.data('id')
				};

				$.ajax({
					url: $$.Config.removeCartUrl,
					method: 'POST',
					data: data,
					success: function success(response) {
						response = $.parseJSON(response);

						if (response.success) {
							$$.Noty['successMessage'](response.success);
							card.remove();

							$('.js-sum-all').text(response.SUM);
							$('.js-count-all').text(response.amount);
							$('.js-count-text-all').text(response.text_amount);

							if (!response.amount) {
								_this._clearCart();
							}
						} else {
							$$.Noty['errorMessage'](response.error);
						}
					}
				});
			});

			this.nodes.cards.on('click', '.SALE_DELAY_ELEM', function (event) {
				var delayLink = $(event.currentTarget);
				var card = delayLink.closest('.js-card');

				event.preventDefault();

				$.ajax({
					url: delayLink.attr('href'),
					method: 'GET',
					success: function success(response) {
						response = $.parseJSON(response);

						if (response.success) {
							$$.Noty['successMessage'](response.success);
							card.remove();

							$('.js-sum-all').text(response.SUM);
							$('.js-count-all').text(response.amount);
							$('.js-count-text-all').text(response.text_amount);

							if (!response.amount) {
								_this._clearCart();
							}
						} else {
							$$.Noty['errorMessage'](response.error);
						}
					}
				});
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this.nodes.invalidMessage.hide();
			this.nodes.discountMessage.hide();

			this.nodes.codeContaiter.show();
		}
	}, {
		key: '_clearCart',
		value: function _clearCart() {
			this.nodes.cards.remove();
			this.nodes.summary.remove();
			this.nodes.finish.remove();
			this.nodes.cardsContainer.append('<p><font class="errortext">Ваша корзина пуста</font></p>');

			var cartSmall = $('.js-cart-small');

			cartSmall.find('.empty-cart').removeClass('hidden');
			cartSmall.find('.money').addClass('hidden');
		}
	}]);

	return Cart;
})();

Number.isInteger = Number.isInteger || function (value) {
	return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.CatalogMenu = (function () {
	function CatalogMenu(root) {
		_classCallCheck(this, CatalogMenu);

		this.root = root;
		this.rootHeight = $(this.root).height();
		this.rootTopPadding = parseInt($(this.root).position().top, 10);

		this.initialize();

		this._cacheNodes();
		this._bindEvents();
	}

	_createClass(CatalogMenu, [{
		key: 'initialize',
		value: function initialize() {
			$$.body.css({ minHeight: this.rootHeight + this.rootTopPadding });
		}
	}, {
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				logo: this.root.find('.js-logo-wrapper'),
				search: this.root.find('.js-search-wrapper'),
				searchInput: this.root.find('.js-menu-search'),
				searchButton: this.root.find('.js-menu-search-button'),
				menu: this.root.find('.js-catalog-menu'),
				notFirstLevel: this.root.find('.js-catalog-menu-second-level,' + '.js-catalog-menu-third-level,' + '.js-catalog-menu-product-level'),
				menuItems: this.root.find('.js-catalog-menu-item')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.root.on('mouseenter', function (event) {
				$(event.currentTarget).on('mousewheel', function (event) {
					_this._scrollMenu(event, 'root');
				});
			}).on('mouseleave', function (event) {
				$(event.currentTarget).off('mousewheel');
			});

			this.nodes.notFirstLevel.on('mouseenter', function (event) {
				$(event.currentTarget).on('mousewheel', function (event) {
					_this._scrollMenu(event, 'notRoot');
				});
			}).on('mouseleave', function (event) {
				$(event.currentTarget).off('mousewheel');
			});
		}
	}, {
		key: '_scrollMenu',
		value: function _scrollMenu(event, level) {
			if (this.nodes.searchInput.hasClass('focus')) {
				return;
			}

			var items;
			var itemFirst;
			var fullHeight;
			var scrollStep;
			var marginTop;
			var maxMarginTop;

			if (level === 'root') {
				fullHeight = this.nodes.logo.height() + this.nodes.search.height() + this.nodes.menu.height();
				scrollStep = this.nodes.menu.children(this.nodes.menuItems).height();
				marginTop = parseInt(this.nodes.logo.css('margin-top'), 10);
			} else if (level === 'notRoot') {
				items = $(event.currentTarget).children(this.nodes.menuItems);
				itemFirst = items.first();
				fullHeight = itemFirst.height() * items.length + parseInt($(event.currentTarget).css('padding-top'), 10);
				scrollStep = itemFirst.height();
				marginTop = parseInt(itemFirst.css('margin-top'), 10);
			}

			maxMarginTop = fullHeight - $$.windowHeight;

			if (scrollStep > $$.windowHeight) {
				scrollStep = $$.windowHeight;
			}

			if (fullHeight > $$.windowHeight) {
				if (event.deltaY > 0) {
					marginTop = marginTop + scrollStep;
					if (marginTop > 0) {
						marginTop = 0;
					}
				} else if (event.deltaY < 0) {
					marginTop = marginTop - scrollStep;
					if (marginTop < -maxMarginTop) {
						marginTop = -maxMarginTop;
					}
				}

				if (level === 'root') {
					this.nodes.logo.css({ marginTop: marginTop });
					this.nodes.searchInput.css({ top: marginTop + 60 });
					this.nodes.searchButton.css({ top: marginTop + 60 });
				} else if (level === 'notRoot') {
					itemFirst.css({ marginTop: marginTop });
				}
			}
		}
	}]);

	return CatalogMenu;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.CollapseBlocks = (function () {
	function CollapseBlocks(root) {
		_classCallCheck(this, CollapseBlocks);

		this.root = root;

		this._cacheNodes();
		this._bindEvents();
	}

	_createClass(CollapseBlocks, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				block: this.root.find('.js-collapse-block')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			this.nodes.block.on('click', function (event) {
				$(event.currentTarget).toggleClass('opened');
			});
		}
	}]);

	return CollapseBlocks;
})();
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $$ = $$ || {};

$$.ContactsMap = (function () {
	function GoogleMap() {
		var root = arguments.length <= 0 || arguments[0] === undefined ? $ : arguments[0];
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, GoogleMap);

		var defaultOptions = {
			mapOptions: {
				zoom: 14,
				styles: [{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [{ "color": "#444444" }]
				}, {
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [{ "color": "#f2f2f2" }]
				}, {
					"featureType": "poi",
					"elementType": "all",
					"stylers": [{ "visibility": "off" }]
				}, {
					"featureType": "road",
					"elementType": "all",
					"stylers": [{ "saturation": -100 }, { "lightness": 45 }]
				}, {
					"featureType": "road.highway",
					"elementType": "all",
					"stylers": [{ "visibility": "simplified" }]
				}, {
					"featureType": "road.arterial",
					"elementType": "labels.icon",
					"stylers": [{ "visibility": "off" }]
				}, {
					"featureType": "transit",
					"elementType": "all",
					"stylers": [{ "visibility": "off" }]
				}, {
					"featureType": "water",
					"elementType": "all",
					"stylers": [{ "color": "#0088f6" }, { "visibility": "on" }]
				}],
				disableDefaultUI: true
			},
			rootDefaultHeight: 300,
			rootExpandHeight: 600,
			mapDefaultTop: -150,
			mapExpandTop: 0
		};

		this.map;
		this.centerMap;

		this.root = root;
		this.options = _.merge(options || {}, defaultOptions, _.defaults);
		this.initialize();

		this._cacheNodes();
		this._bindEvents();
	}

	_createClass(GoogleMap, [{
		key: "initialize",
		value: function initialize() {
			var _this = this;

			setTimeout(function () {
				_this._createMap();
			}, 0);
		}
	}, {
		key: "_cacheNodes",
		value: function _cacheNodes() {
			this.nodes = {
				map: this.root.find('.js-map'),
				expandMap: this.root.find('.js-expand-map'),
				expandMapText: this.root.find('.js-expand-map-text'),
				reduceMapText: this.root.find('.js-reduce-map-text')
			};
		}
	}, {
		key: "_bindEvents",
		value: function _bindEvents() {
			var _this2 = this;

			setTimeout(function () {
				$$.window.on('resize', function () {
					_this2.map.setCenter(_this2.centerMap);
				});

				_this2.nodes.expandMap.on('click', function (event) {
					if (!$(event.currentTarget).data('expand')) {
						$(event.currentTarget).data('expand', true);
						_this2.root.height(_this2.options.rootExpandHeight);
						_this2.nodes.map.css({ top: _this2.options.mapExpandTop });
						_this2.nodes.expandMapText.hide();
						_this2.nodes.reduceMapText.show();
					} else {
						$(event.currentTarget).data('expand', false);
						_this2.root.height(_this2.options.rootDefaultHeight);
						_this2.nodes.map.css({ top: _this2.options.mapDefaultTop });
						_this2.nodes.expandMapText.show();
						_this2.nodes.reduceMapText.hide();
					}

					return false;
				});
			}, 0);
		}
	}, {
		key: "_createMap",
		value: function _createMap() {
			var _this3 = this;

			var coordinates = this.nodes.map.data('coordinates');

			this.centerMap = new google.maps.LatLng(coordinates[0], coordinates[1]);
			this.map = new google.maps.Map(this.nodes.map.get(0), this.options.mapOptions);
			this.map.setCenter(this.centerMap);

			google.maps.event.addListenerOnce(this.map, 'idle', function () {
				_this3.updatedMapCenter = _this3._calculateCenter();
				_this3._addMarker();
				_this3.map.setCenter(_this3.updatedMapCenter);
			});
		}
	}, {
		key: "_calculateCenter",
		value: function _calculateCenter() {
			var projection = this.map.getProjection();
			var wc = projection.fromLatLngToPoint(this.centerMap);
			var sw = new google.maps.Point(wc.x, wc.y);

			return projection.fromPointToLatLng(sw);
		}
	}, {
		key: "_addMarker",
		value: function _addMarker() {
			new google.maps.Marker({
				position: this.centerMap,
				map: this.map,
				//animation: google.maps.Animation.DROP,
				icon: '/site/assets/images/point.png'
			});
		}
	}]);

	return GoogleMap;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.ContentSlider = (function () {
	function ContentSlider(root, options) {
		_classCallCheck(this, ContentSlider);

		this.root = root;
		this.currentSlide = 0;
		this.isAnimating = false;

		var defaultOptions = {
			duration: 300,
			easing: 'swing',
			slideWidth: 700
		};

		if (this.root.hasClass('js-content-slider-promo')) {
			defaultOptions.slideWidth = this.root.width();
		}

		this.options = _.assign(defaultOptions, options);

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(ContentSlider, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				itemsWrapper: this.root.find('.js-items'),
				backward: this.root.find('.js-backward'),
				forward: this.root.find('.js-forward'),
				currentSlide: this.root.find('.js-current-slide'),
				countSlides: this.root.find('.js-count-slides'),
				items: this.root.find('.js-item'),
				description: this.root.find('.js-description')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.backward.on('click', function () {
				_this._previousSlide();
			});

			this.nodes.forward.on('click', function () {
				_this._nextSlide();
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this.nodes.countSlides.text(this.nodes.items.length);

			if (this.root.hasClass('js-content-slider-promo')) {
				this.nodes.items.width(this.options.slideWidth);
				this.nodes.itemsWrapper.width(this.options.slideWidth * this.nodes.items.length);
			}
		}
	}, {
		key: '_nextSlide',
		value: function _nextSlide() {
			this.nodes.description.eq(this.currentSlide).removeClass('show');
			this.currentSlide = this.currentSlide + 1;
			this._goToSlide(this.currentSlide);
		}
	}, {
		key: '_previousSlide',
		value: function _previousSlide() {
			this.nodes.description.eq(this.currentSlide).removeClass('show');
			this.currentSlide = this.currentSlide - 1;
			this._goToSlide(this.currentSlide);
		}
	}, {
		key: '_goToSlide',
		value: function _goToSlide(slideNumber) {
			var _this2 = this;

			if (this.isAnimating) {
				return;
			}

			if (slideNumber < 0) {
				this.currentSlide = this.nodes.items.length - 1;
				this._goToEnd();
				return;
			} else if (slideNumber >= this.nodes.items.length) {
				this.currentSlide = 0;
				this._goToStart();
				return;
			}

			this.isAnimating = true;
			this.nodes.description.eq(slideNumber).addClass('show');
			this.nodes.currentSlide.text(slideNumber + 1);

			this.nodes.itemsWrapper.animate({
				marginLeft: -this.options.slideWidth * slideNumber
			}, this.options.duration, this.options.easing, function () {
				_this2.isAnimating = false;
			});
		}
	}, {
		key: '_goToEnd',
		value: function _goToEnd() {
			var _this3 = this;

			var slideItem = this.nodes.items.last().clone();
			var temporaryItemsWidth = this.nodes.itemsWrapper.width() + this.options.slideWidth;

			this.nodes.itemsWrapper.prepend(slideItem);
			this.nodes.itemsWrapper.css({
				marginLeft: -this.options.slideWidth,
				width: temporaryItemsWidth
			});
			this.nodes.currentSlide.text(this.currentSlide + 1);
			this.nodes.description.last().addClass('show');

			this.nodes.itemsWrapper.animate({
				marginLeft: 0
			}, this.options.duration, this.options.easing, function () {
				var marginLeft = -_this3.currentSlide * _this3.options.slideWidth;

				_this3.isAnimating = false;
				_this3.nodes.itemsWrapper.css({
					marginLeft: marginLeft,
					width: temporaryItemsWidth - _this3.options.slideWidth
				});
				slideItem.remove();
			});
		}
	}, {
		key: '_goToStart',
		value: function _goToStart() {
			var _this4 = this;

			var slideItem = this.nodes.items.first().clone();
			var temporaryItemsWidth = this.nodes.itemsWrapper.width() + this.options.slideWidth;

			this.nodes.itemsWrapper.width(temporaryItemsWidth).append(slideItem);
			this.nodes.currentSlide.text(this.currentSlide + 1);
			this.nodes.description.first().addClass('show');

			this.nodes.itemsWrapper.animate({
				marginLeft: -this.nodes.items.length * this.options.slideWidth
			}, this.options.duration, 'swing', function () {
				slideItem.remove();
				_this4.nodes.itemsWrapper.css({
					marginLeft: 0,
					width: temporaryItemsWidth - _this4.options.slideWidth
				});
				_this4.isAnimating = false;
			});
		}
	}]);

	return ContentSlider;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.Delivery = (function () {
	function Delivery(root) {
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, Delivery);

		var defaultOptions = {};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.activeForm = 1;
		this.formLastValues = {};
		this.lastCityValue = "";
		this.lastDeliveryId = false;

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(Delivery, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				switchTabButtons: this.root.find('.js-phisic, .js-jur'),

				radio: this.root.find('[name="PERSON_TYPE"]'),

				submitButton: this.root.find('.js-submit'),

				form: this.root.find('form'),

				pointsContainer: this.root.find('.js-points-container'),

				phisicCity: this.root.find('.js-phisic-city'),
				jurCity: this.root.find('.js-jur-city'),
				cityFields: this.root.find('.js-phisic-city, .js-jur-city').closest('.line').children('.f-input'),

				orderWeightInput: this.root.find('[name="ORDER_WEIGHT"]'),
				orderPriceInput: this.root.find('[name="ORDER_PRICE"]'),

				city: this.root.find('.f-delivery [name="ORDER_PROP_6_val"]'),

				chooseAPlaceEx: this.root.find('.f-delivery .FILD-ADDRESS')
			};

			this._cachePoints();
		}
	}, {
		key: '_cachePoints',
		value: function _cachePoints() {
			var _this = this;

			this.nodes.price = this.nodes.pointsContainer.find('.price');

			this.nodes.points = this.nodes.pointsContainer.find('.js-points');
			this.nodes.subPoints = this.nodes.pointsContainer.find('.js-sub-points');
			this.nodes.deliveryAddresses = this.nodes.pointsContainer.find('.js-address');

			this.nodes.subPoints.slideUp(1);

			this._toggleDeliveryAddress(this.nodes.deliveryAddresses.eq(0).val());

			this.nodes.deliveryAddresses.on('click', function (event) {
				_this._toggleDeliveryAddress($(event.currentTarget).val());
			});

			this.nodes.points.on('click', '> .item', function (event) {
				var currentPoint = $(event.currentTarget);

				if (currentPoint.hasClass('active')) {
					event.stopPropagation();
					return;
				}

				var childPoints = currentPoint.find('.js-sub-points');

				_this.nodes.subPoints.filter('.active').removeClass('active').slideUp().find(':checked').removeAttr('checked');

				if (childPoints.length) {
					childPoints.addClass('active').stop(true).slideDown();

					if (!childPoints.find(':checked').length) {
						childPoints.find('input').eq(0).prop('checked', true);

						var price = childPoints.find('.js-delivery-price').eq(0);

						_this.nodes.price.text(price.length ? price.text() : 0);
					}
				} else {
					var price = currentPoint.find('.js-delivery-price').eq(0);

					_this.nodes.price.text(price.length ? price.text() : 0);
				}
			});

			this.nodes.points.find('> .item.active').each(function (index, element) {
				var price = $(element).find('.js-delivery-price').eq(0);

				_this.nodes.price.text(price.length ? price.text() : 0);
			});

			this.nodes.subPoints.on('click', function (event) {
				event.stopPropagation();
			});
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this2 = this;

			this.nodes.switchTabButtons.on('click', function (event) {
				var current = $(event.currentTarget);
				var itIsFormPhisic = _this2.activeForm === 1 && current.hasClass('js-phisic');
				var itIsFormJur = _this2.activeForm === 2 && current.hasClass('js-jur');
				var city;

				if (itIsFormPhisic || itIsFormJur) {
					return false;
				} else if (current.hasClass('js-phisic')) {
					_this2.activeForm = 1;

					city = _this2.nodes.phisicCity.val();
				} else if (current.hasClass('js-jur')) {
					_this2.activeForm = 2;

					city = _this2.nodes.jurCity.val();
				}

				_this2._changePersonType();

				_this2._updatePoints(_this2.activeForm, city, _this2.nodes.orderWeightInput.val(), _this2.nodes.orderPriceInput.val());
			});

			this.nodes.phisicCity.get(0).onchange = function () {
				_this2._updatePoints(_this2.activeForm, _this2.nodes.phisicCity.val(), _this2.nodes.orderWeightInput.val(), _this2.nodes.orderPriceInput.val());
			};

			this.nodes.jurCity.get(0).onchange = function () {
				_this2._updatePoints(_this2.activeForm, _this2.nodes.jurCity.val(), _this2.nodes.orderWeightInput.val(), _this2.nodes.orderPriceInput.val());
			};

			this.nodes.cityFields.on('focus', function (event) {
				_this2.lastCityValue = $(event.currentTarget).val();
			}).on('blur', function (event) {
				if ($(event.currentTarget).val() !== _this2.lastCityValue) {
					$(event.currentTarget).val('');
				}

				_this2.lastCityValue = "";
			}).on('keydown', function (event) {
				if (event.keyCode === 13) {
					// enter
					$('.search-popup .search-popup-row').first().trigger('click');

					return false;
				}
			});

			this.nodes.submitButton.on('click', function (event) {
				event.preventDefault();

				if (_this2._checkForm()) {
					_this2.nodes.form.submit();
				}
			});

			this.nodes.chooseAPlaceEx.on('focus', function (event) {
				if ($(event.currentTarget).val() === '') {
					$('#SDEK_selectPVZ').trigger('click');
				}
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this._changePersonType();

			this.nodes.radio.hide();

			this.nodes.form.find('.f-input[required]').data('required', true);
			this.nodes.form.find('.f-input').each(function (index, element) {
				$(element).removeAttr('required');
			});
		}
	}, {
		key: '_changePersonType',
		value: function _changePersonType() {
			this.nodes.radio.removeAttr('checked');
			this.nodes.radio.eq(this.activeForm - 1).attr('checked', true).trigger('click');
		}
	}, {
		key: '_updatePoints',
		value: function _updatePoints(type, city, weight, price) {
			var _this3 = this;

			$.ajax({
				url: $$.Config.changeDelivery,
				method: 'POST',
				data: {
					type: type,
					city: city,
					weight: weight,
					price: price
				}
			}).done(function (response) {
				$('#SDEK_pvz, #SDEK_mask').remove();

				_this3.nodes.pointsContainer.html(response);

				try {
					if (_this3.nodes.pointsContainer.find('#POSTAMAT').length) {
						var tmpHTML = $('#SDEK_pvz').html();
						$('#SDEK_pvz').html('');
						$('#SDEK_pvz').attr('id', 'SDEK_notInUse');
						$('body').append("<div id='SDEK_pvz'>" + tmpHTML + "</div>");
						ymaps.ready(IPOLSDEK_pvz.init);
						IPOLSDEK_pvz.initCityPVZ();
					}
				} catch (e) {
					console.log(e);
				}

				_this3._cachePoints();
			}).fail(function (response) {
				$$.Noty['errorMessage'](response);
			});
		}
	}, {
		key: '_toggleDeliveryAddress',
		value: function _toggleDeliveryAddress(id) {
			var _this4 = this;

			this.nodes.form.find('.js-delivery-address-id').val(id);

			var activeFormClass = this._activeFormClass();
			var activeForm = this.nodes.form.find(activeFormClass + '-city').closest('.f-delivery');
			var toHide = '.delivery_hiden_' + id;
			var toHidePrev = '.delivery_hiden_' + this.lastDeliveryId;
			var notRequired = '.no_required_' + id;
			var notRequiredPrev = '.no_required_' + this.lastDeliveryId;
			var elem;
			var childrenInput;

			activeForm.find('.f-input').removeClass('error');

			if (this.lastDeliveryId) {
				activeForm.find(toHidePrev).each(function (index, element) {
					elem = $(element);
					childrenInput = elem.find('.f-input');

					elem.show();
					childrenInput.data('required', true);
					childrenInput.val(_this4.formLastValues[childrenInput.attr('id')]);
				});

				activeForm.find('.block').show();

				activeForm.find(notRequiredPrev).data('required', true).closest('.line, .small').children('.label').addClass('required');
			}

			activeForm.find('.f-input').each(function (index, element) {
				elem = $(element);

				_this4.formLastValues[elem.attr('id')] = elem.val();
			});

			activeForm.find(toHide).each(function (index, element) {
				elem = $(element);
				childrenInput = elem.find('.f-input');

				elem.hide();
				childrenInput.data('required', false);

				childrenInput.val('');
			});

			activeForm.find(notRequired).data('required', false).closest('.line, .small').children('.label').removeClass('required');

			$('.js-tab' + activeFormClass).trigger('click');

			this.nodes.points.find('#TEXT_DELIVERY_' + this.lastDeliveryId).hide();
			this.nodes.points.find('#TEXT_DELIVERY_' + id).show();

			this.lastDeliveryId = id;
		}
	}, {
		key: '_activeFormClass',
		value: function _activeFormClass() {
			var activeFormClass;

			if (this.activeForm === 1) {
				activeFormClass = '.js-phisic';
			} else if (this.activeForm === 2) {
				activeFormClass = '.js-jur';
			} else {
				activeFormClass = false;
			}

			return activeFormClass;
		}
	}, {
		key: '_checkForm',
		value: function _checkForm() {
			var _this5 = this;

			var activeFormClass = this._activeFormClass();

			var activeForm = this.nodes.form.find(activeFormClass + '-city').closest('.f-delivery');
			var elem;
			var checkType;

			activeForm.find('.f-input').each(function (index, element) {
				elem = $(element);

				if (elem.data('required')) {
					checkType = _this5._fieldType(elem);

					if (_this5._checkField(elem.val(), checkType)) {
						elem.removeClass('error');
					} else {
						elem.addClass('error');
					}
				}
			});

			if (activeForm.find('.f-input.error').length > 0) {
				return false;
			} else {
				return true;
			}
		}
	}, {
		key: '_checkField',
		value: function _checkField(value, checkType) {
			value = $.trim(value);

			if (value === '') {
				return false;
			}

			if (checkType === 'string') {
				if (value > '') {
					return true;
				}
			} else if (checkType === 'email') {
				if (value.indexOf("@") > 0) {
					return true;
				}
			}

			return false;
		}
	}, {
		key: '_fieldType',
		value: function _fieldType(elem) {
			var type = elem.attr('type');
			var requiredType = $.trim(elem.closest('.line, .small').children('.label').text());
			var checkType = '';

			if (type === 'text') {
				checkType = 'string';
			}

			if (requiredType === 'E-Mail') {
				checkType = 'email';
			}

			return checkType;
		}
	}]);

	return Delivery;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.DeliveryPopup = (function () {
    function DeliveryPopup(root) {
        _classCallCheck(this, DeliveryPopup);

        this.root = root;

        this._cacheNodes();
        this._bindEvents();
    }

    _createClass(DeliveryPopup, [{
        key: '_cacheNodes',
        value: function _cacheNodes() {
            this.nodes = {
                title: this.root.find('.js-popup-title'),
                content: this.root.find('.js-popup-content')
            };
        }
    }, {
        key: '_bindEvents',
        value: function _bindEvents() {
            var _this = this;

            $$.body.on('mouseup', function (event) {
                if (!_this.root.has(event.target).length) {
                    _this.nodes.content.css('display', 'none');
                }
            });

            this.nodes.title.on('click', function (event) {
                _this._showOrHidePopup();
            });
        }
    }, {
        key: '_showOrHidePopup',
        value: function _showOrHidePopup() {
            if (this.nodes.content.css('display') === 'none') {
                this.nodes.content.css('display', 'block');
            } else {
                this.nodes.content.css('display', 'none');
            }
        }
    }]);

    return DeliveryPopup;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.FacebookPixel = (function () {
	function FacebookPixel() {
		_classCallCheck(this, FacebookPixel);
	}

	_createClass(FacebookPixel, [{
		key: 'reachGoal',
		value: function reachGoal(goal, data) {
			if (fbq) {
				if (data) {
					fbq('track', goal, data);
				} else {
					fbq('track', goal);
				}
			}
		}
	}]);

	return FacebookPixel;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.FeedbackSlider = (function () {
	function FeedbackSlider(root, options) {
		_classCallCheck(this, FeedbackSlider);

		this.root = root;
		this.currentSlide = 0;
		this.isAnimating = false;

		this.options = {
			duration: 300,
			easing: 'swing'
		};

		this.slidesCount = 0;
		this.slideWidth = $$.windowWidth;

		_.assign(this.options, options);
		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(FeedbackSlider, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				itemsWrapper: this.root.find('.js-items'),
				backward: this.root.find('.js-backward'),
				forward: this.root.find('.js-forward'),
				bullsWrapper: this.root.find('.js-pages'),
				currentSlide: this.root.find('.js-current-slide'),
				items: this.root.find('.js-item'),
				description: this.root.find('.js-description')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.backward.on('click', function () {
				_this._previousSlide();
			});

			this.nodes.forward.on('click', function () {
				_this._nextSlide();
			});

			$$.window.on('resize', function () {
				_this._resize();
				_this._goToStart();
			});

			this.nodes.bullsWrapper.on('click', '.js-page', function (event) {
				var currentBull = $(event.currentTarget);
				_this._goToSlide(currentBull.index());
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this.showCount = $$.windowWidth / 480 | 0;

			this.nodes.items.filter(':nth-of-type(' + this.showCount + 'n)').css({
				marginRight: $$.windowWidth - this.showCount * 480
			});

			this.slidesCount = Math.ceil(this.nodes.items.length / this.showCount);

			this.nodes.bullsWrapper.empty();

			for (var i = 1; i <= this.slidesCount; i++) {
				this.nodes.bullsWrapper.append('<div class="page js-page"/>');
			}
		}
	}, {
		key: '_resize',
		value: function _resize() {
			$$.windowWidth = $$.window.width();
			this.nodes.items.css({ marginRight: 0 });

			this.showCount = $$.windowWidth / 480 | 0;

			this.nodes.items.filter(':nth-of-type(' + this.showCount + 'n)').css({
				marginRight: $$.windowWidth - this.showCount * 480
			});

			this.slidesCount = Math.ceil(this.nodes.items.length / this.showCount);

			this.slideWidth = $$.windowWidth;

			this.nodes.bullsWrapper.empty();

			for (var i = 1; i <= this.slidesCount; i++) {
				this.nodes.bullsWrapper.append('<div class="page js-page"/>');
			}
		}
	}, {
		key: '_nextSlide',
		value: function _nextSlide() {
			this.nodes.description.eq(this.currentSlide).removeClass('show');
			this.currentSlide = this.currentSlide + 1;
			this._goToSlide(this.currentSlide);
		}
	}, {
		key: '_previousSlide',
		value: function _previousSlide() {
			this.nodes.description.eq(this.currentSlide).removeClass('show');
			this.currentSlide = this.currentSlide - 1;
			this._goToSlide(this.currentSlide);
		}
	}, {
		key: '_goToSlide',
		value: function _goToSlide(slideNumber) {
			var _this2 = this;

			if (this.isAnimating) {
				return;
			}

			if (slideNumber < 0) {
				this.currentSlide = this.slidesCount - 1;
				this._goToEnd();
				return;
			} else if (slideNumber >= this.slidesCount) {
				this.currentSlide = 0;
				this._goToStart();
				return;
			}

			this.isAnimating = true;

			this.nodes.itemsWrapper.animate({
				marginLeft: -this.slideWidth * slideNumber
			}, this.options.duration, this.options.easing, function () {
				_this2.isAnimating = false;
			});

			this.currentSlide = slideNumber;
			this.nodes.bullsWrapper.find('.js-page').removeClass('active').eq(this.currentSlide).addClass('active');
		}
	}, {
		key: '_goToEnd',
		value: function _goToEnd() {
			var _this3 = this;

			var slideItem = this.nodes.items.last().clone();

			this.nodes.itemsWrapper.prepend(slideItem);
			this.nodes.itemsWrapper.css({ marginLeft: -this.slideWidth });

			this.nodes.itemsWrapper.animate({
				marginLeft: 0
			}, this.options.duration, this.options.easing, function () {
				var marginLeft = -_this3.currentSlide * _this3.slideWidth;

				_this3.isAnimating = false;
				_this3.nodes.itemsWrapper.css({ marginLeft: marginLeft });
				slideItem.remove();
			});

			this.currentSlide = this.slidesCount;
			this.nodes.bullsWrapper.find('.js-page').removeClass('active').eq(this.currentSlide).addClass('active');
		}
	}, {
		key: '_goToStart',
		value: function _goToStart() {
			var _this4 = this;

			var slideItem = this.nodes.items.first().clone();

			this.nodes.itemsWrapper.append(slideItem);

			this.nodes.itemsWrapper.animate({
				marginLeft: -this.nodes.items.length * this.slideWidth
			}, this.options.duration, 'swing', function () {
				slideItem.remove();
				_this4.nodes.itemsWrapper.css({ marginLeft: 0 });
				_this4.isAnimating = false;
			});

			this.currentSlide = 0;
			this.nodes.bullsWrapper.find('.js-page').removeClass('active').eq(this.currentSlide).addClass('active');
		}
	}]);

	return FeedbackSlider;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.FixedHeader = (function () {
	function FixedHeader(root) {
		_classCallCheck(this, FixedHeader);

		this.root = root;

		this._bindEvents();
	}

	_createClass(FixedHeader, [{
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			$$.window.on('scroll', _.debounce(function (event) {
				var scrollTop = event.currentTarget.scrollY;

				if (scrollTop > 0) {
					_this.root.css({ backgroundColor: '#fff' });
				} else {
					_this.root.css({ backgroundColor: 'transparent' });
				}
			}, 100, {
				leading: true
			})).trigger('scroll');
		}
	}]);

	return FixedHeader;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.FormTabs = (function () {
	function FormTabs(root, options) {
		_classCallCheck(this, FormTabs);

		this.root = root;

		this.options = {};

		_.assign(this.options, options);
		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(FormTabs, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				links: this.root.find('.js-tab-link'),
				forms: this.root.find('form')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.links.on('click', function (event) {
				event.preventDefault();
				var currentTab = $(event.currentTarget);

				_this.nodes.links.removeClass('active');
				currentTab.addClass('active');

				_this.nodes.forms.hide();
				_this.nodes.forms.eq(currentTab.index()).show();
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this.nodes.forms.eq(1).hide();

			this.nodes.forms.each(function () {
				var _this2 = this;

				$(this).validate({
					submitHandler: function submitHandler(form) {
						form = $(form);

						$.ajax({
							url: form.attr('action'),
							method: form.attr('method'),
							data: form.serialize(),
							success: function success(response) {
								response = $.parseJSON(response);

								if (response.success) {
									$$.Noty['successMessage'](response.success);
									_this2.root.trigger('tabFormSubmit');
								} else {
									_.each(response.errors, function (value, key) {
										var input = form.find('input[name="' + key + '"]').addClass('error');
										var error = $('<label class="error">' + value + '</label>');

										error.insertAfter(input);
									});
								}
							}
						});
					}
				});
			});
		}
	}]);

	return FormTabs;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.GoogleAnalytics = (function () {
	function GoogleAnalytics() {
		_classCallCheck(this, GoogleAnalytics);

		if (!window.ga) {
			//console.log('ga error');
		}
	}

	_createClass(GoogleAnalytics, [{
		key: 'reachGoal',
		value: function reachGoal(goal) {
			if (window.ga) {
				ga('t0.send', 'event', 'click', goal); // "t0." если есть тег менеджер
			}
		}
	}, {
		key: 'reachPage',
		value: function reachPage(page) {
			if (window.ga) {
				ga('t0.send', 'pageview', page); // "t0." если есть тег менеджер
			}
		}
	}]);

	return GoogleAnalytics;
})();
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {})();

var GoogleMap = (function () {
	function GoogleMap(root) {
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, GoogleMap);

		var defaultOptions = {
			offset: false,
			coords: [-34.397, 150.644],
			mapOptions: {
				mapTypeId: !_.isUndefined(window.google) ? google.maps.MapTypeId.ROADMAP : '', //MapTypeId.SATELLITE, MapTypeId.HYBRID, MapTypeId.TERRAIN
				maxZoom: 45,
				zoom: 15,
				minZoom: 0,
				zoomControl: true,
				overviewMapControl: true,
				styles: [{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [{ "color": "#444444" }]
				}, {
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [{ "color": "#f2f2f2" }]
				}, {
					"featureType": "poi",
					"elementType": "all",
					"stylers": [{ "visibility": "off" }]
				}, {
					"featureType": "road",
					"elementType": "all",
					"stylers": [{ "saturation": -100 }, { "lightness": 45 }]
				}, {
					"featureType": "road.highway",
					"elementType": "all",
					"stylers": [{ "visibility": "simplified" }]
				}, {
					"featureType": "road.arterial",
					"elementType": "labels.icon",
					"stylers": [{ "visibility": "off" }]
				}, {
					"featureType": "transit",
					"elementType": "all",
					"stylers": [{ "visibility": "off" }]
				}, {
					"featureType": "water",
					"elementType": "all",
					"stylers": [{ "color": "#0088f6" }, { "visibility": "on" }]
				}],
				disableDefaultUI: true
			}
		};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.MercatorProjection = null;
		this.MapIcon = null;
		this.MapCenter = null;

		if (!_.isUndefined(window.google)) {
			this.gm = google.maps;
			this._ready();
		}
	}

	_createClass(GoogleMap, [{
		key: "initialize",
		value: function initialize() {}
	}, {
		key: "_createMap",
		value: function _createMap() {
			var _this = this;

			var centerMap = new this.gm.LatLng(this.options.coords[0], this.options.coords[1]);
			this.map = new this.gm.Map(this.root.get(0), this.options.mapOptions);
			this.map.setCenter(centerMap);
			this.MapCenter = centerMap;

			google.maps.event.addListenerOnce(this.map, 'idle', function (f) {
				if (_this.options.offset) {
					_this.MercatorProjection = new MercatorProjection(_this.map);

					var offset = _this.root.width() - _this.options.offset;

					var point = new google.maps.Point(offset / 2, _this.root.height() / 2);
					var latLng = _this.MercatorProjection.PixelToLatLng(point);

					_this.map.setCenter(latLng);

					_this.MapCenter = latLng;
				}
			});

			google.maps.event.addListener(this.map, 'click', _.bind(function (event) {
				this.trigger('mapClick', event);
			}, this));

			google.maps.event.addListener(this.map, 'zoom_changed', function (f) {
				if (_this.MapCenter) {
					_this.map.panTo(_this.MapCenter);
				}
			});

			google.maps.event.addListener(this.map, 'dragstart', _.bind(function (event) {
				this.center = null;
			}, this));
		}
	}, {
		key: "_cacheNodes",
		value: function _cacheNodes() {
			this.nodes = {};
		}
	}, {
		key: "_bindEvents",
		value: function _bindEvents() {}
	}, {
		key: "_ready",
		value: function _ready() {
			this.gm.event.addDomListener(window, 'load', this._createMap());

			this.icon = {
				url: '/site/assets/images/point.png',
				size: [32, 43]
			};

			/*if (!this.nodes.addresses.length) {
   	return;
   }
   		this.nodes.addresses.each((index) => {
   	var item = $(this);
   	var coords = $.parseJSON(item.data('coords').json);
   			this.marker = coords;
   			item.on('click', function (e) {
   		e.preventDefault();
   		var item = $(this);
   				if (item.hasClass('active')) {
   			return;
   		}
   				item.siblings().removeClass('active').end().addClass('active');
   				GoogleMaps.panTo = coords;
   	})
   });*/
		}
	}, {
		key: "icon",
		set: function set(value) {
			if (value) {
				this.MapIcon = {
					url: value.url,
					size: new google.maps.Size(value.size[0], value.size[1]),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(value.size[0] / 2, value.size[1])
				};
			}
		},
		get: function get() {
			return this.MapIcon;
		}
	}, {
		key: "marker",
		set: function set(value) {
			var position = null;

			_.isArray(value) ? position = new this.gm.LatLng(value[0], value[1]) : position = value;

			var icon = this.icon == null ? '' : this.icon;

			var marker = new this.gm.Marker({
				position: position,
				map: this.map,
				icon: icon
			});

			google.maps.event.addListener(marker, 'click', _.bind(function () {
				this.panTo = marker.getPosition();
			}, this));
		}
	}, {
		key: "center",
		set: function set(value) {
			var position = null;

			_.isArray(value) ? position = new this.gm.LatLng(value[0], value[1]) : position = value;

			this.map.setCenter(position);

			this.MapCenter = position;
		}
	}, {
		key: "panTo",
		set: function set(value) {
			var position = null;

			_.isArray(value) ? position = new this.gm.LatLng(value[0], value[1]) : position = value;

			this.map.panTo(position);
			this.MapCenter = position;

			if (this.MercatorProjection) {
				var offset = this.root.width() - this.options.offset;

				var point = new google.maps.Point(offset / 2, this.root.height() / 2);
				var latLng = this.MercatorProjection.PixelToLatLng(point);
				this.map.panTo(latLng);

				this.MapCenter = latLng;
			}
		}
	}]);

	return GoogleMap;
})();

var MercatorProjection = (function () {
	function MercatorProjection(map) {
		_classCallCheck(this, MercatorProjection);

		this.map = map;
		this.mapOverlay = new google.maps.OverlayView();
		this.mapOverlay.draw = function () {};

		this.pixelOrigin_ = new google.maps.Point(TILE_SIZE / 2, TILE_SIZE / 2);

		this._ready();
	}

	/**
  * Specified LatLng value is used to calculate pixel coordinates and
  * update the control display. Container is also repositioned.
  * @param {google.maps.LatLng} latLng Position to display
  */

	_createClass(MercatorProjection, [{
		key: "LatLngToPixel",
		value: function LatLngToPixel(latLng) {
			var projection = this.mapOverlay.getProjection();
			var point = projection.fromLatLngToContainerPixel(latLng);
			return point;
		}

		/**
   * Specified LatLng value is used to calculate pixel coordinates and
   * update the control display. Container is also repositioned.
   * @param {google.maps.Point} Point Position to display
   */
	}, {
		key: "PixelToLatLng",
		value: function PixelToLatLng(point) {
			var projection = this.mapOverlay.getProjection();
			var newPoint = projection.fromContainerPixelToLatLng(point);

			return newPoint;
		}
	}, {
		key: "_ready",
		value: function _ready() {
			this.mapOverlay.setMap(this.options.map);
		}
	}]);

	return MercatorProjection;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.Header = (function () {
	function Header(root) {
		_classCallCheck(this, Header);

		this.root = root;
		this.additionalClass = '';
		this.searchInputDefaultClass = '';
		this.isOpened = false;
		this.currentName = '';

		this.allClasses = {};
		this.tabStates = {};

		this.options = {
			duration: 300,
			defaultHeight: 61,
			easing: 'swing'
		};

		this.oldHeight = this.options.defaultHeight;
		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(Header, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				listItems: this.root.find('.js-list-item'),
				closeIcons: this.root.find('.js-close-icon'),
				searchInput: this.root.find('.js-search-input'),
				clearableInputs: this.root.find('.js-clearable-input'),
				cityItems: this.root.find('.js-city-item'),
				cityLinks: this.root.find('.js-city-link'),
				contentInner: this.root.find('.js-content-inner'),
				overlay: $('.js-header-overlay'),
				cityNameInHeader: this.root.find('.js-city-name-in-header'),
				menuSearchInput: $('.js-menu-search'),
				forms: this.root.find('.feedback-form form')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.listItems.on('click', function (event) {
				if (!$(event.currentTarget).hasClass('active')) {
					_this._toggleMenu($(event.currentTarget));
				}

				return false;
			});

			$$.body.on('openfeedback', function (event) {
				event.preventDefault();

				_this._toggleMenu(_this.nodes.listItems.filter('.js-feedback'));
			});

			this.nodes.closeIcons.on('click', function () {
				_this._closeHeader();
			});

			this.nodes.searchInput.on('input', function () {
				_this._inputHandler();
			}).on('keypress', function (event) {
				if (event.keyCode === 13) {
					// enter
					var maxIndex = _this.nodes.cityItems.length - 1;
					var lastIndex = 0;

					$(_this.nodes.cityItems).each(function (index, event) {
						lastIndex = index;

						if (!$(event).hasClass('letter') && !$(event).hasClass('hidden')) {
							$(event).children('.js-city-link').trigger("click");

							return false;
						}
					});

					if (lastIndex === maxIndex) {
						_this.nodes.searchInput.val('');
						_this._inputHandler();

						return false;
					}
				}
			});

			this.root.on('click', function (event) {
				event.stopPropagation();
			});

			this.nodes.overlay.on('click', function () {
				_this._closeHeader();
			});

			this.nodes.cityLinks.on('click', function (event) {
				var currentCity = $(event.currentTarget);

				if (currentCity.hasClass('disabled') || currentCity.hasClass('letter')) {
					return false;
				}

				_this._citySelect(currentCity);

				//return false;
			});

			$$.window.on('keydown', function (event) {
				if (event.keyCode !== $$.ESCAPE_KEY_CODE) {
					return;
				}

				_this._closeHeader();
			});

			this.nodes.menuSearchInput.on('focus', function () {
				_this._closeHeader();
			});

			this.nodes.forms.each(function (index, element) {
				$(element).validate({
					submitHandler: function submitHandler(form) {
						form = $(form);

						$.ajax({
							url: form.attr('action'),
							method: form.attr('method'),
							data: form.serialize(),
							success: function success(response) {
								response = $.parseJSON(response);

								if (response.success) {
									_this._closeHeader();
									$$.Noty['successMessage'](response.success);
									_this.root.trigger('headerFormSubmit');
								} else {
									_.each(response.errors, function (value, key) {
										var input = form.find('input[name="' + key + '"]').addClass('error');
										var error = $('<label class="error">' + value + '</label>');

										error.insertAfter(input);
									});
								}
							}
						});
					}
				});
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this.iconSpace = -7;

			this.currentCity = this.nodes.cityItems.filter(function (index, city) {
				return $(city).hasClass('disabled');
			}).first();
		}
	}, {
		key: '_calculateScrollWidth',
		value: function _calculateScrollWidth() {
			return $$.body.get(0).scrollHeight > $$.body.height() ? 20 : 0;
		}
	}, {
		key: '_citySelect',
		value: function _citySelect(currentCity) {
			var cityName = currentCity.text();

			this.nodes.cityNameInHeader.text(cityName);
			this.currentCity.removeClass('disabled');
			this.currentCity = currentCity;
			this.currentCity.addClass('disabled');
			this._closeHeader();
		}
	}, {
		key: '_closeHeader',
		value: function _closeHeader() {
			var _this2 = this;

			this.nodes.clearableInputs.val('');
			this.currentName = '';
			this._dropSearchState();
			this.nodes.overlay.removeClass('show');

			this.nodes.overlay.fadeOut();

			this.root.animate({
				height: this.options.defaultHeight
			}, this.options.duration, this.options.easing, function () {
				_this2.oldHeight = _this2.options.defaultHeight;
				_this2.isOpened = false;

				_.forEach(_this2.allClasses, function (state) {
					_this2.root.removeClass(state);
				});
			});
		}
	}, {
		key: '_dropSearchState',
		value: function _dropSearchState() {
			if (!this.root.hasClass(this.root.data('searchCity'))) {
				return;
			}

			this.nodes.searchInput.val('');
			this.root.removeClass(this.root.data('searchCity'));
			this.nodes.cityItems.removeClass('hidden');
		}
	}, {
		key: '_inputHandler',
		value: function _inputHandler() {
			if (!this.searchInputDefaultClass) {
				this.searchInputDefaultClass = this.additionalClass;
			}

			var searchData = this.nodes.searchInput.val().toLowerCase();

			if (searchData) {
				this.root.removeClass(this.additionalClass);
				this.additionalClass = this.root.data('searchCity');
				this.root.addClass(this.additionalClass);

				this.nodes.cityItems.removeClass('hidden');
				this.root.stop();

				this.nodes.cityItems.filter(function (index, element) {
					var cityItem = $(element);
					var cityItemName = cityItem.text().toLowerCase();
					var isValidStart = !_.startsWith(cityItemName, searchData);
					var isValidLetter = cityItem.hasClass('letter') && _.first(searchData) === cityItemName;

					return isValidStart && !isValidLetter;
				}).addClass('hidden');
			} else {
				this.root.removeClass(this.additionalClass);
				this.additionalClass = this.searchInputDefaultClass;
				this.root.addClass(this.additionalClass);

				this.nodes.cityItems.removeClass('hidden');
			}

			var oldHeight = this.root.height();

			this.root.css({ height: 'auto' });

			var realHeight = this.root.height();

			this.root.css({ height: oldHeight });

			this.root.animate({
				height: realHeight
			}, this.options.duration);
		}
	}, {
		key: '_toggleMenu',
		value: function _toggleMenu(listItem) {
			var _this3 = this;

			var currentName = _.trim(listItem.text());
			var currentAdditionalClass = this.additionalClass;
			var additionalClass = listItem.data('for');
			var scrollWidth = this._calculateScrollWidth();

			if (currentName === this.currentName) {
				this._closeHeader();
				return;
			}

			this.nodes.closeIcons.css({ right: this.iconSpace + scrollWidth });
			this.allClasses[additionalClass] = additionalClass;
			this._dropSearchState();
			this.currentName = currentName;

			if (!listItem.hasClass('js-tab')) {
				currentAdditionalClass = additionalClass;
			} else {
				this.nodes.listItems.removeClass('active');
				listItem.addClass('active');
			}

			if (!listItem.hasClass('js-tab') && !(currentAdditionalClass in this.tabStates) || listItem.hasClass('js-tab')) {
				this.tabStates[currentAdditionalClass] = additionalClass;
			}

			_.forEach(this.allClasses, function (state) {
				_this3.root.removeClass(state);
			});

			this.additionalClass = currentAdditionalClass;
			this.root.addClass(this.tabStates[this.additionalClass]);
			this.root.css({ height: 'auto' });

			var endHeight = this.root.height();

			this.root.css({ height: this.oldHeight });

			if (!this.isOpened) {
				this.nodes.overlay.fadeIn();
			}

			this.root.animate({
				height: endHeight
			}, this.options.duration, 'swing', function () {
				_this3.oldHeight = endHeight;
				_this3.isOpened = true;
			});
		}
	}]);

	return Header;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.LearnHowToOrder = (function () {
	function LearnHowToOrder(root, options) {
		_classCallCheck(this, LearnHowToOrder);

		this.root = root;

		this._bindEvents();
	}

	_createClass(LearnHowToOrder, [{
		key: '_bindEvents',
		value: function _bindEvents() {
			this.root.on('click', function (event) {
				event.preventDefault();

				$('.js-upper-header .js-feedback').trigger('click');
				$('.p-user-form.call-me.feedback-form').find('.tab').last().trigger('click');
			});
		}
	}]);

	return LearnHowToOrder;
})();
'use strict';

var $$ = $$ || {};

$$.Noty = {
	confirmCity: function confirmCity(city, cityId) {
		"use strict";

		var n = noty({
			layout: 'top',
			text: 'Ваш город — ' + city + '?',
			theme: 'elementTheme',
			type: 'confirm',
			template: '\n\t\t\t<div class="noty_message">\n\t\t\t<span class="noty_text"></span>\n\t\t\t<div class="noty_close"></div>\n\t\t\t</div>\n\t\t\t',
			animation: {
				open: 'animated fadeInDown', // Animate.css class names
				close: 'animated fadeOutUp', // Animate.css class names
				easing: 'swing', // unavailable - no need
				speed: 500 // unavailable - no need
			},
			closeWith: ['button'],
			callback: {
				onShow: function onShow() {
					var _this = this;

					this.$bar.find('.noty_bar').append('<div class="noty_label">От выбора города зависит способ и стоимость доставки.</div>');
					$('<span class="noty_close g-icon g-icon-close"></span>').appendTo(this.$bar.find('.noty_bar')).on('click', function (event) {
						_this.close();
					});
				},
				afterShow: function afterShow() {},
				onClose: function onClose() {},
				afterClose: function afterClose() {},
				onCloseClick: function onCloseClick() {}
			},
			buttons: [{
				addClass: 'button', text: 'Да', onClick: function onClick($noty) {
					$.ajax({
						url: $$.Config.confirmCity,
						method: 'POST',
						data: {
							id: cityId
						},
						success: function success(response) {
							response = $.parseJSON(response);

							if (response.success) {
								$noty.close();
							}
						}
					});
				}
			}, {
				addClass: 'button', text: 'Выбрать другой', onClick: function onClick($noty) {
					$('.js-city-name-in-header').trigger('click');
					$noty.close();
				}
			}]
		});
	},
	successMessage: function successMessage(message) {
		"use strict";

		var n = noty({
			layout: 'top',
			text: message,
			theme: 'elementTheme',
			type: 'success',
			template: '\n\t\t\t<div class="noty_message">\n\t\t\t<span class="noty_text"></span>\n\t\t\t<div class="noty_close g-icon g-icon-close"></div>\n\t\t\t</div>\n\t\t\t',
			animation: {
				open: 'animated fadeInDown', // Animate.css class names
				close: 'animated fadeOutUp', // Animate.css class names
				easing: 'swing', // unavailable - no need
				speed: 500 // unavailable - no need
			},
			closeWith: ['button'],
			timeout: 1500,
			callback: {
				onShow: function onShow() {},
				afterShow: function afterShow() {
					var _this2 = this;

					if (this.options.timeout) {
						setTimeout(function () {
							_this2.close();
						}, this.options.timeout);
					}
				},
				onClose: function onClose() {},
				afterClose: function afterClose() {},
				onCloseClick: function onCloseClick() {}
			},
			buttons: false
		});
	},
	errorMessage: function errorMessage(message) {
		"use strict";

		var close = arguments.length <= 1 || arguments[1] === undefined ? 2000 : arguments[1];
		var n = noty({
			layout: 'top',
			text: message,
			theme: 'elementTheme',
			type: 'error',
			template: '\n\t\t\t<div class="noty_message">\n\t\t\t<span class="noty_text"></span>\n\t\t\t<div class="noty_close g-icon g-icon-close"></div>\n\t\t\t</div>\n\t\t\t',
			animation: {
				open: 'animated fadeInDown', // Animate.css class names
				close: 'animated fadeOutUp', // Animate.css class names
				easing: 'swing', // unavailable - no need
				speed: 500 // unavailable - no need
			},
			closeWith: ['button'],
			timeout: close,
			callback: {
				onShow: function onShow() {},
				afterShow: function afterShow() {
					var _this3 = this;

					if (this.options.timeout) {
						setTimeout(function () {
							_this3.close();
						}, this.options.timeout);
					}
				},
				onClose: function onClose() {},
				afterClose: function afterClose() {},
				onCloseClick: function onCloseClick() {}
			},
			buttons: false
		});
	}
};

$.noty.themes.elementTheme = {
	name: 'elementTheme',
	helpers: {
		borderFix: function borderFix() {
			if (this.options.dismissQueue) {
				var selector = this.options.layout.container.selector + ' ' + this.options.layout.parent.selector;
				switch (this.options.layout.name) {
					case 'top':

						//$(selector).css({borderRadius: '0px 0px 0px 0px'});
						//$(selector).last().css({borderRadius: '0px 0px 5px 5px'});
						break;
					case 'topCenter':
					case 'topLeft':
					case 'topRight':
					case 'bottomCenter':
					case 'bottomLeft':
					case 'bottomRight':
					case 'center':
					case 'centerLeft':
					case 'centerRight':
					case 'inline':
						$(selector).css({ borderRadius: '0px 0px 0px 0px' });
						$(selector).first().css({ 'border-top-left-radius': '5px', 'border-top-right-radius': '5px' });
						$(selector).last().css({
							'border-bottom-left-radius': '5px',
							'border-bottom-right-radius': '5px'
						});
						break;
					case 'bottom':
						$(selector).css({ borderRadius: '0px 0px 0px 0px' });
						$(selector).first().css({ borderRadius: '5px 5px 0px 0px' });
						break;
					default:
						break;
				}
			}
		}
	},
	modal: {
		css: {
			position: 'fixed',
			width: '100%',
			height: '100%',
			backgroundColor: '#000',
			zIndex: 10000,
			opacity: 0.6,
			display: 'none',
			left: 0,
			top: 0
		}
	},
	style: function style() {
		this.$bar.on({
			mouseenter: function mouseenter() {
				$(this).find('.noty_close').stop().fadeTo('normal', 1);
			},
			mouseleave: function mouseleave() {
				$(this).find('.noty_close').stop().fadeTo('normal', 0);
			}
		});

		switch (this.options.layout.name) {
			case 'top':
				break;
			case 'topCenter':
			case 'center':
			case 'bottomCenter':
			case 'inline':
				this.$bar.css({
					borderRadius: '5px',
					border: '1px solid #eee',
					boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
				});
				this.$message.css({ fontSize: '13px', textAlign: 'center' });
				break;
			case 'topLeft':
			case 'topRight':
			case 'bottomLeft':
			case 'bottomRight':
			case 'centerLeft':
			case 'centerRight':
				this.$bar.css({
					borderRadius: '5px',
					border: '1px solid #eee',
					boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
				});
				this.$message.css({ fontSize: '13px', textAlign: 'left' });
				break;
			case 'bottom':
				this.$bar.css({
					borderRadius: '5px 5px 0px 0px',
					borderTop: '2px solid #eee',
					borderLeft: '2px solid #eee',
					borderRight: '2px solid #eee',
					boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.1)"
				});
				break;
			default:
				this.$bar.css({
					border: '2px solid #eee',
					boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
				});
				break;
		}

		switch (this.options.type) {
			case 'alert':
			case 'notification':
				this.$bar.css({ backgroundColor: '#FFF', borderColor: '#CCC', color: '#444' });
				break;
			case 'warning':
				this.$bar.css({ backgroundColor: '#FFEAA8', borderColor: '#FFC237', color: '#826200' });
				this.$buttons.css({ borderTop: '1px solid #FFC237' });
				break;
			case 'error':
				/*this.$bar.css({backgroundColor: 'red', borderColor: 'darkred', color: '#FFF'});
     this.$message.css({fontWeight: 'bold'});
     this.$buttons.css({borderTop: '1px solid darkred'});*/
				break;
			case 'information':
				this.$bar.css({ backgroundColor: '#57B7E2', borderColor: '#0B90C4', color: '#FFF' });
				this.$buttons.css({ borderTop: '1px solid #0B90C4' });
				break;
			case 'success':
				this.$bar.css({ backgroundColor: 'lightgreen', borderColor: '#50C24E', color: 'darkgreen' });
				this.$buttons.css({ borderTop: '1px solid #50C24E' });
				break;
			case 'confirm':
				/*this.$bar.css({
     backgroundColor: 'lightgreen', borderColor: '#50C24E', color: 'darkgreen'
     });
     this.$buttons.css({borderTop: '1px solid #50C24E'});*/
				break;
			default:
				this.$bar.css({ backgroundColor: '#FFF', borderColor: '#CCC', color: '#444' });
				break;
		}
	},
	callback: {
		onShow: function onShow() {
			$.noty.themes.elementTheme.helpers.borderFix.apply(this);
		},
		onClose: function onClose() {
			$.noty.themes.elementTheme.helpers.borderFix.apply(this);
		}
	}
};
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.OpenPopup = (function () {
	function OpenPopup(root) {
		_classCallCheck(this, OpenPopup);

		this.root = root;

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(OpenPopup, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			this.root.on('click', function (event) {
				var button = $(event.currentTarget);

				$$.Popup.openPopup(button.data('popup'));
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {}
	}]);

	return OpenPopup;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.PageNotFound = (function () {
	function PageNotFound(root) {
		_classCallCheck(this, PageNotFound);

		this.root = root;
		this.sources = this.root.data('sources');
		this.currentImageUrl = _.first(this.sources);

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(PageNotFound, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				whoIs: this.root.find('.js-who-is')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.whoIs.on('click', function (event) {
				event.preventDefault();
				_this._checkoutImage();
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			var _this2 = this;

			this.timeOutId = setTimeout(function () {
				_this2._checkoutImage();
			}, 8000);
		}
	}, {
		key: '_checkoutImage',
		value: function _checkoutImage() {
			var _this3 = this;

			var sources = _.reject(this.sources, function (image) {
				return image === _this3.currentImageUrl;
			});

			this.currentImageUrl = sources[_.random(sources.length - 1)];
			this.root.css('background-image', 'url(' + this.currentImageUrl + ')');
			clearTimeout(this.timeOutId);

			this.timeOutId = setTimeout(function () {
				_this3._checkoutImage();
			}, 8000);
		}
	}]);

	return PageNotFound;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.PartnerForm = (function () {
	function PartnerForm(root) {
		_classCallCheck(this, PartnerForm);

		this.root = root;

		this._bindEvents();
		this._cacheNodes();
		this._ready();
	}

	_createClass(PartnerForm, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				form: this.root.find('.js-form')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {}
	}, {
		key: '_ready',
		value: function _ready() {
			var _this = this;

			this.nodes.form.validate({
				submitHandler: function submitHandler(form) {
					form = $(form);

					$.ajax({
						url: form.attr('action'),
						method: form.attr('method'),
						data: form.serialize(),
						success: function success(response) {
							response = $.parseJSON(response);

							if (response.success) {
								$$.Noty['successMessage'](response.success);
								_this.root.trigger('partnerFormSubmit');
							} else {
								_.each(response.errors, function (value, key) {
									var input = form.find('input[name="' + key + '"]').addClass('error');
									var error = $('<label class="error">' + value + '</label>');

									error.insertAfter(input);
								});
							}
						}
					});
				}
			});
		}
	}]);

	return PartnerForm;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.Popup = (function () {
	function Popup(root) {
		_classCallCheck(this, Popup);

		this.root = root;

		this.popupContentProperty = {};

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(Popup, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				contents: this.root.find('.js-popup-content'),
				close: this.root.find('.js-close-popup')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.root.on('click', function (event) {
				var targetElement = $(event.target);

				if (targetElement.get(0) == _this.root.get(0) || targetElement.get(0) == _this.nodes.close.get(0)) {
					_this._closePopup();
				}
			});

			this.nodes.contents.on('partnerFormSubmit', function () {
				_this._closePopup();
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			var _this2 = this;

			this.nodes.contents.each(function (index, content) {
				_this2.popupContentProperty[$(content).data('popup-content-name')] = $(content).css('display');
				$(content).css({ display: 'none' });
			});
		}
	}, {
		key: 'openPopup',
		value: function openPopup(popupContentName) {
			$('body').css({ overflow: 'hidden' });
			this.root.show();

			this.root.find('.js-popup-content[data-popup-content-name=' + popupContentName + ']').css({
				display: this.popupContentProperty[popupContentName]
			});
		}
	}, {
		key: '_closePopup',
		value: function _closePopup() {
			$('body').css({ overflow: 'auto' });
			this.root.hide();

			this.nodes.contents.css({ display: 'none' });
		}
	}]);

	return Popup;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.ProductCard = (function () {
	function ProductCard(root) {
		_classCallCheck(this, ProductCard);

		this.root = root;

		this._bindEvents();
	}

	_createClass(ProductCard, [{
		key: '_bindEvents',
		value: function _bindEvents() {
			this.root.on('click', '.js-remove', function (event) {
				if ($(event.currentTarget).data('id')) {
					var data = {
						action: "delete",
						id: $(event.currentTarget).data('id')
					};

					$.ajax({
						url: $$.Config.deleteInCart,
						method: 'POST',
						data: data,
						success: function success(response) {
							response = $.parseJSON(response);

							if (response.success) {
								$$.Noty['successMessage'](response.success);
								$(event.delegateTarget).remove();
							} else {
								$$.Noty['errorMessage'](response.error);
							}
						}
					});
				}
			});
		}
	}]);

	return ProductCard;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.ProductCards = (function () {
	function ProductCards(root) {
		_classCallCheck(this, ProductCards);

		this.root = root;

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(ProductCards, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				wrapper: this.root.find('.js-inner'),
				items: this.root.find('.js-item'),
				progressBar: this.root.find('.js-progress-wrapper')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			$$.window.on('resize', _.debounce(function () {
				_this._hideShowCards();
			}, 200));
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this._hideShowCards();

			this.nodes.progressBar.addClass('not-hover');
		}
	}, {
		key: '_hideShowCards',
		value: function _hideShowCards() {
			var wrapperWidth = this.nodes.wrapper.width();
			var itemWidth = this.nodes.items.innerWidth();
			var fitItems = parseInt(wrapperWidth / itemWidth);
			var itemsLength = this.nodes.items.length;

			fitItems < 4 ? fitItems = 4 : null;

			this.nodes.progressBar.width(itemsLength * itemWidth + 1);

			this.nodes.items.each(function (index, event) {
				if (index >= fitItems) {
					$(event).hide();
				} else {
					$(event).show();
				}
			});
		}
	}]);

	return ProductCards;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.ProfilePage = (function () {
	function ProfilePage(root) {
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, ProfilePage);

		var defaultOptions = {};
		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(ProfilePage, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				addNumber: this.root.find('.js-add-number'),
				input: this.root.find('input'),
				phone: this.root.find('input.phone'),
				saveButton: this.root.find('.js-save'),
				cancelButton: this.root.find('.js-cancel'),
				editButton: this.root.find('.js-edit'),
				addJurAddress: this.root.find('.js-add-jur-address'),
				jurAddressForm: this.root.find('.js-jur-address-form')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.editButton.on('click', function (event) {
				event.preventDefault();
				var item = $(event.currentTarget);
				item.parents('.form-part').addClass('edit');

				if (_this.root.find('input.phone').length < 2) {
					_this.nodes.addNumber.show();
				}
			});

			var phoneTemplate = '\n\t\t\t<div class="row">\n                <div class="col-xs-12">\n                    <div class="value"></div>\n                    <input type="text" class="phone" name="PERSONAL_PHONE" value="" name="phone"/>\n                </div>\n            </div>\n\t\t';

			this.nodes.addNumber.on('click', function (event) {
				"use strict";
				event.preventDefault();
				var item = $(event.currentTarget);

				if (item.parent().find('input').length >= 2) {
					return;
				}

				var newPhoneField = $(phoneTemplate).appendTo(item.parent());

				_this._initMask(newPhoneField.find('input'));
				newPhoneField.find('input').on("focusout", function (event) {
					return _this._clearBrokenPhoneNumber(event);
				});

				_this._updatePhoneFields(item);

				$(event.currentTarget).hide();
			});

			this.nodes.saveButton.on('click', function (event) {
				"use strict";
				var item = $(event.currentTarget);
				var form = item.parents('form');

				item.parents('.form-part').find('input').removeClass('error');

				var phoneOne = item.parents('.form-part').find('input.phone').eq(0);
				var phoneTwo = item.parents('.form-part').find('input.phone').eq(1);

				if (phoneOne.val() === '' && phoneTwo.val() > '') {
					phoneOne.val(phoneTwo.val());
					phoneOne.closest('div').children('.value').text(phoneTwo.val());

					phoneTwo.val('');
					phoneTwo.closest('div').children('.value').text('');
				}

				$.ajax({
					url: form.attr('action'),
					method: form.attr('method'),
					data: form.serialize(),
					beforeSend: function beforeSend() {
						if (phoneTwo.val() === '') {
							phoneTwo.closest('.row').remove();
							phoneOne.closest('.row').removeClass('tr');
						}
					},
					success: function success(response) {
						response = $.parseJSON(response);

						if (response.success) {
							$$.Noty['successMessage'](response.success);

							item.parents('.form-part').find('input').each(function (index, element) {
								var input = $(element);
								var value = $$.trim(input.val());
								var label = input.siblings('.value');

								if (value !== '') {
									label.text(value);
								} else {
									label.text('');
								}
							});

							var select = item.parents('.form-part').find('select option:selected');
							select.parents('.field').find('.value').text(select.text());

							item.parents('.form-part').removeClass('edit');
							_this.nodes.addNumber.hide();
						} else {
							_.each(response.errors, function (value, key) {
								item.parents('.form-part').find('input[name="' + key + '"]').addClass('error');
								$$.Noty['errorMessage'](value, 4000);
							});
						}
					}
				});
			});

			this.nodes.cancelButton.on('click', function (event) {
				event.preventDefault();
				var item = $(event.currentTarget);

				if (item.parent().hasClass('disabled')) {
					return;
				}

				item.parents('.form-part').find('.field input').each(function (index, element) {
					"use strict";

					$(element).val($$.trim($(element).closest('div').children('.value').text()));

					if ($(element).hasClass('.phone')) {
						if ($$.trim($(element).siblings().text()) === '') {
							$(element).parent().parent().remove();
						}
					}
				});

				_this._updatePhoneFields(_this.nodes.addNumber);

				item.parents('.form-part').removeClass('edit');
				_this.nodes.addNumber.hide();
			});

			this.root.on('change', 'input', function (event) {
				var input = $(event.target);
				var label = input.closest('.value');

				label.text(input.val());
			});

			this.root.find('.password-subscribe input').one('change', function (event) {
				"use strict";
				var item = $(event.currentTarget);
				item.parents('form').find('.save-wrap').removeClass('disabled');
				item.parents('form').find('input[type="submit"]').removeAttr('disabled');
			});

			this.root.find('form').on('submit', function (event) {
				"use strict";
				event.preventDefault();
				var form = $(event.currentTarget);
				form.find('.save-wrap').addClass('disabled');
				form.find('input[type="submit"]').attr('disabled', 'disabled');
				form.find('input').removeClass('error');

				$.ajax({
					url: form.attr('action'),
					method: form.attr('method'),
					data: form.serialize(),
					success: function success(response) {
						response = $.parseJSON(response);

						if (response.success) {
							$$.Noty['successMessage'](response.success);

							$(form).find('input.checkbox').each(function (index, element) {
								if ($(element).context.checked) {
									$(element).attr('checked', true);
								} else {
									$(element).attr('checked', false);
								}
							});
						} else {
							_.each(response.errors, function (value, key) {
								key = key.replace(/\-/g, "_");
								form.find('input[name="' + key + '"]').addClass('error');
								$$.Noty['errorMessage'](value, 4000);
							});
						}
					},
					complete: function complete() {
						form.find('.save-wrap').removeClass('disabled');
						form.find('input[type="submit"]').removeAttr('disabled');
					}
				});
			});

			this.nodes.phone.on("focusout", function (event) {
				return _this._clearBrokenPhoneNumber(event);
			});

			this.nodes.addJurAddress.one('click', function (event) {
				event.preventDefault();

				_this.nodes.jurAddressForm.show();

				$(event.currentTarget).hide();
			});
		}
	}, {
		key: '_updatePhoneFields',
		value: function _updatePhoneFields(item) {
			"use strict";

			item.parent().find('.row').each(function (index, element) {
				if (index === item.parent().find('.row').length - 1) {
					$(element).removeClass('tr');
				} else {
					$(element).addClass('tr');
				}
			});
		}

		/**
   *
   * @param selector jQuery объект
   * @private
   */

	}, {
		key: '_initMask',
		value: function _initMask(selector) {
			"use strict";

			var im = new Inputmask("8 (999) 999-99-99");
			im.mask(selector.get(0));
		}
	}, {
		key: '_clearBrokenPhoneNumber',
		value: function _clearBrokenPhoneNumber(event) {
			if ($(event.currentTarget).val().indexOf("_") > 0) {
				$(event.currentTarget).val($(event.currentTarget).closest('div').children('.value').text());
			}
		}
	}, {
		key: '_ready',
		value: function _ready() {
			"use strict";

			var _this2 = this;

			this.root.find('input.phone').each(function (index, element) {
				_this2._initMask($(element));
			});

			if (this.root.find('input.phone').length > 1) {
				this.nodes.addNumber.hide();
			} else {
				$$.trim(this.root.find('input.phone').parent().children('.value').text());
			}

			this.nodes.jurAddressForm.find('input').each(function (index, element) {
				if ($(element).val() > '') {
					_this2.nodes.jurAddressForm.show();
					_this2.nodes.addJurAddress.hide();

					return;
				}
			});
		}
	}]);

	return ProfilePage;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.RegistrationEvent = (function () {
    function RegistrationEvent(root) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        _classCallCheck(this, RegistrationEvent);

        var defaultOptions = {};
        this.root = root;
        this.options = _.assign(defaultOptions, options);

        this._cacheNodes();
        this._bindEvents();
        this._ready();
    }

    _createClass(RegistrationEvent, [{
        key: '_cacheNodes',
        value: function _cacheNodes() {
            this.nodes = {
                phone: this.root.find('.phone'),
                scrollBottomButton: $('.js-scroll-bottom-registration')
            };
        }
    }, {
        key: '_bindEvents',
        value: function _bindEvents() {
            var _this = this;

            this.root.on('submit', function (event) {
                event.preventDefault();

                _this.root.find('input').removeClass('error');

                $.ajax({
                    url: _this.root.attr('action'),
                    method: _this.root.attr('method'),
                    data: _this.root.serialize(),
                    success: function success(response) {
                        if (response.success) {
                            $$.Noty['successMessage'](response.success);
                            _this.root.trigger('registrationEventFormSubmit');

                            if (response.redirect) {
                                window.location = response.redirect;
                            }

                            _this.root.hide();
                            _this.nodes.scrollBottomButton.hide();
                        } else {
                            _.each(response.errors, function (value, key) {
                                _this.root.find('input[name="' + key + '"]').addClass('error');
                                $$.Noty['errorMessage'](value, 4000);
                            });
                        }
                    },
                    dataType: 'json'
                });
            });

            this.nodes.phone.on('focusout', function (event) {
                return _this._clearBrokenPhoneNumber(event);
            });
        }
    }, {
        key: '_clearBrokenPhoneNumber',
        value: function _clearBrokenPhoneNumber(event) {
            if ($(event.currentTarget).val().indexOf('_') > 0) {
                $(event.currentTarget).val('');
            }
        }
    }, {
        key: '_ready',
        value: function _ready() {
            this.nodes.phone.each(function (index, element) {
                var inputMask = new Inputmask('8 (999) 999-99-99');

                inputMask.mask(element);
            });
        }
    }]);

    return RegistrationEvent;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.RegistrationPage = (function () {
	function ProfilePage(root) {
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, ProfilePage);

		var defaultOptions = {};
		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.formStates = {
			closed: 'g-icon-eye-closed',
			opened: 'g-icon-eye-opened'
		};

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(ProfilePage, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				addNumber: this.root.find('.js-add-number'),
				eye: this.root.find('.js-eye'),
				passwordInput: this.root.find('.js-password-input'),
				phone: this.root.find('.phone')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			var phoneTemplate = '<input class="input phone" name="REGISTER[PERSONAL_PHONE]" id="phone1" type="text">';

			this.nodes.addNumber.one('click', function (event) {
				"use strict";
				event.preventDefault();
				var item = $(event.currentTarget);

				if (item.parent().find('input').length >= 2) {
					return;
				}

				var newPhoneField = $(phoneTemplate).appendTo(item.parent()).on("focusout", function (event) {
					return _this._clearBrokenPhoneNumber(event);
				});

				_this._initMask(newPhoneField);

				$(event.currentTarget).remove();
			});

			this.nodes.eye.on('click', function () {
				_this._togglePasswordInput();
			});

			this.root.find('form').on('submit', function (event) {
				"use strict";
				event.preventDefault();

				var form = $(event.currentTarget);
				form.find('input').removeClass('error');

				/**
     REGISTER[LOGIN] = REGISTER[EMAIL]
     REGISTER[CONFIRM_PASSWORD] = REGISTER[PASSWORD]
     */

				form.find('[name="REGISTER[LOGIN]"]').val(form.find('[name="REGISTER[EMAIL]"]').val());
				form.find('[name="REGISTER[CONFIRM_PASSWORD]"]').val(form.find('[name="REGISTER[PASSWORD]"]').val());

				$.ajax({
					url: form.attr('action'),
					method: form.attr('method'),
					data: form.serialize(),
					success: function success(response) {
						response = $.parseJSON(response);

						if (response.success) {
							$$.Noty['successMessage'](response.success);
							_this.root.trigger('registrationFormSubmit');

							if (response.redirect) {
								window.location = response.redirect;
							}
						} else {
							_.each(response.errors, function (value, key) {
								form.find('input[name="' + key + '"]').addClass('error');
								$$.Noty['errorMessage'](value, 4000);
							});
						}
					}
				});
			});

			this.nodes.phone.on("focusout", function (event) {
				return _this._clearBrokenPhoneNumber(event);
			});
		}

		/**
   *
   * @param selector jQuery объект
   * @private
   */

	}, {
		key: '_initMask',
		value: function _initMask(selector) {
			"use strict";

			var im = new Inputmask("8 (999) 999-99-99");
			im.mask(selector.get(0));
		}
	}, {
		key: '_clearBrokenPhoneNumber',
		value: function _clearBrokenPhoneNumber(event) {
			if ($(event.currentTarget).val().indexOf("_") > 0) {
				$(event.currentTarget).val("");
			}
		}
	}, {
		key: '_togglePasswordInput',
		value: function _togglePasswordInput() {
			if (this.nodes.eye.hasClass(this.formStates.opened)) {
				this.nodes.eye.removeClass(this.formStates.opened);
				this.nodes.eye.addClass(this.formStates.closed);
				this.nodes.passwordInput.attr('type', 'password');
			} else if (this.nodes.eye.hasClass(this.formStates.closed)) {
				this.nodes.eye.removeClass(this.formStates.closed);
				this.nodes.eye.addClass(this.formStates.opened);
				this.nodes.passwordInput.attr('type', 'text');
			}
		}
	}, {
		key: '_ready',
		value: function _ready() {
			"use strict";

			var _this2 = this;

			this.root.find('input.phone').each(function (index, element) {
				_this2._initMask($(element));
			});
		}
	}]);

	return ProfilePage;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.ScrollBottomRegistration = (function () {
    function ScrollBottomRegistration(root) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        _classCallCheck(this, ScrollBottomRegistration);

        var defaultOptions = {};

        this.root = root;
        this.options = _.assign(defaultOptions, options);

        this.formOffset = 0;

        this._cacheNodes();
        this._bindEvents();
        this._ready();
    }

    _createClass(ScrollBottomRegistration, [{
        key: '_cacheNodes',
        value: function _cacheNodes() {
            this.nodes = {
                form: $('.js-registration-event-form'),
                scrollToButton: this.root.find('.js-scroll-bottom')
            };
        }
    }, {
        key: '_bindEvents',
        value: function _bindEvents() {
            var _this = this;

            $$.window.on('resize', function () {
                _this._resize();
            });

            this.nodes.scrollToButton.on('click', function () {
                $('html, body').animate({ scrollTop: _this.formOffset
                }, 400);
            });
        }
    }, {
        key: '_ready',
        value: function _ready() {
            this._resize();
        }
    }, {
        key: '_resize',
        value: function _resize() {
            this.formOffset = this.nodes.form.offset().top - $$.windowHeight / 3;
        }
    }]);

    return ScrollBottomRegistration;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.ScrollList = (function () {
	function ScrollList(root) {
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, ScrollList);

		var defaultOptions = {
			headerHeight: 60
		};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.containersItemPaddingTop = 0;
		this.linksPaddingTop = 0;

		this.controller = null;

		this._cacheNodes();
		this._cacheReady();
		this._initScrollMagic();
	}

	_createClass(ScrollList, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				linksContainer: this.root.find('.js-links'),
				containersContainer: this.root.find('.js-containers'),
				containersHeader: this.root.find('.js-container-header'),

				scrollToButton: this.root.find('.js-scrollto')
			};

			this.nodes.links = this.nodes.linksContainer.find('.item');
			this.nodes.containers = this.nodes.containersContainer.find('div.item');
		}
	}, {
		key: '_cacheReady',
		value: function _cacheReady() {
			var _this = this;

			var newPaddingTop = parseInt(this.nodes.containersHeader.css('padding-top'), 10);

			if (newPaddingTop === 0 || !newPaddingTop) {
				this.containersItemPaddingTop = 29; // todo 29 margin h3
				newPaddingTop = this.containersItemPaddingTop + 1;
			} else {
				newPaddingTop = newPaddingTop + 3;
			}

			this.linksPaddingTop = newPaddingTop + parseInt(this.nodes.containersContainer.parent().css('padding-top'), 10);

			this.nodes.scrollToButton.on('click', function (event) {
				event.preventDefault();

				if (_this.controller) {
					var target = $(event.currentTarget.getAttribute("href"));

					_this.controller.scrollTo(target.get(0));
				}
			});
		}
	}, {
		key: '_initScrollMagic',
		value: function _initScrollMagic() {
			var _this2 = this;

			this.controller = new ScrollMagic.Controller();

			new ScrollMagic.Scene({
				duration: function duration() {
					return _this2.nodes.containersContainer.height() - _this2.nodes.linksContainer.height() + _this2.linksPaddingTop;
				},
				triggerElement: this.nodes.containersContainer.get(0),
				offset: -this.options.headerHeight - this.linksPaddingTop,
				triggerHook: 0
			}).setPin(this.nodes.linksContainer.get(0)).addTo(this.controller);

			this.controller.scrollTo(function (newpos) {
				$('html, body').stop(true).animate({ scrollTop: newpos - _this2.options.headerHeight - _this2.containersItemPaddingTop });
			});

			this.nodes.links.each(function (index) {
				_this2.nodes.links.eq(index).find('.link').on('click', function (event) {
					event.preventDefault();

					_this2.controller.scrollTo(_this2.nodes.containers.eq(index).get(0));
				});

				new ScrollMagic.Scene({
					duration: $$.windowHeight,
					triggerElement: _this2.nodes.containers.eq(index).get(0),
					triggerHook: 1
				}).setClassToggle(_this2.nodes.links.eq(index).get(0), "active").addTo(_this2.controller);
			});
		}
	}]);

	return ScrollList;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var MainSlider = (function () {
	function MainSlider() {
		var root = arguments.length <= 0 || arguments[0] === undefined ? $ : arguments[0];
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, MainSlider);

		var defaultOptions = {};

		//super(root, _.merge(options || {}, defaultOptions, _.defaults));

		//$$.Emitter.call(this);
	}

	_createClass(MainSlider, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				slides: this.root.find('.slide'),
				arrows: this.root.find('.slide-button'),
				pagination: this.root.find('.pagination')
			};
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this._resizeSlider();
			this._initSpring();

			this.slidesLength = this.nodes.slides.length;
			this.nodes.pagination.append('<ul />');

			for (var i = 1; i <= this.slidesLength; i++) {
				this.nodes.pagination.find('ul').append('<li/>');
			}

			this.nodes.pagination = this.nodes.pagination.find('li');
			this.index = 0;

			this.nodes.pagination.eq(this.index).addClass('active');
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.on('slideChange', _.bind(function () {
				this.nodes.pagination.eq(this.index).siblings().removeClass('active');
				this.nodes.pagination.eq(this.index).addClass('active');
			}, this));

			this.nodes.arrows.on('click', event = function (event) {
				var item = $(event.currentTarget);

				var newIndex = _this.index + item.data('direction');

				if (newIndex < 0) {
					newIndex = _this.slidesLength - 1;
				} else if (newIndex > _this.slidesLength - 1) {
					newIndex = 0;
				}

				if (item.data('direction') > 0) {
					_this.nodes.slides.eq(_this.index).data('spring').target(-1);

					_this.nodes.slides.eq(newIndex).data('spring').position(1);
					_this.nodes.slides.eq(newIndex).data('spring').target(0);
				} else {
					_this.nodes.slides.eq(_this.index).data('spring').target(1);

					_this.nodes.slides.eq(newIndex).data('spring').position(-1);
					_this.nodes.slides.eq(newIndex).data('spring').target(0);
				}

				_this.index = newIndex;

				_this.emit('slideChange');
			});

			this.nodes.pagination.on('click', event = function (event) {
				var item = $(event.currentTarget);

				if (_this.index == item.index()) {
					return;
				}

				_this.setIndex(_this.index, item.index());
			});
		}
	}, {
		key: 'slideRight',
		value: function slideRight(index, newIndex) {
			this.nodes.slides.eq(index).data('spring').target(-1);

			this.nodes.slides.eq(newIndex).data('spring').position(1);
			this.nodes.slides.eq(newIndex).data('spring').target(0);
		}
	}, {
		key: 'slideLeft',
		value: function slideLeft(index, newIndex) {
			this.nodes.slides.eq(this.index).data('spring').target(1);

			this.nodes.slides.eq(newIndex).data('spring').position(-1);
			this.nodes.slides.eq(newIndex).data('spring').target(0);
		}
	}, {
		key: '_initSpring',
		value: function _initSpring() {
			this.nodes.slides.each(function (index) {
				var item = $(this);

				var spring = new $$.Simulation.Spring({
					rigidness: 100,
					damping: 1.5,
					target: 1,
					position: 1,
					targetLimits: [-1, 1],
					step: function step() {
						var position = Math.round(this.position() * 1000) / 1000;

						item.css({
							left: 100 * position + '%'
						});
					}
				});

				item.data('spring', spring);
			});

			if (this.nodes.slides.eq(0).data() != undefined) {
				this.nodes.slides.eq(0).data('spring').position(0);
				this.nodes.slides.eq(0).data('spring').target(0);
			}
		}
	}, {
		key: 'setIndex',
		value: function setIndex(index, newIndex) {
			if (index > newIndex) {
				this.slideLeft(index, newIndex);
			} else {
				this.slideRight(index, newIndex);
			}

			this.nodes.pagination.eq(newIndex).siblings().removeClass('active');
			this.nodes.pagination.eq(newIndex).addClass('active');
			this.index = newIndex;
		}
	}, {
		key: '_resizeSlider',
		value: function _resizeSlider() {
			var startWidth = 1420;
			var fontSize = 16;

			$('window').resize(_.bind(function () {
				var currentWidth = $$.window.width() + $$.ScrollWidth();

				if ($('window').width() >= 1420) {
					var ratio = 1420 / startWidth * 100 / 100;

					this.root.css({
						fontSize: fontSize * ratio + 'px'
					});

					return;
				}

				if ($('window').width() <= 960) {
					var ratio = 960 / startWidth * 100 / 100;

					this.root.css({
						fontSize: fontSize * ratio + 'px'
					});

					return;
				}

				var ratio = currentWidth / startWidth * 100 / 100;

				this.root.css({
					fontSize: fontSize * ratio + 'px'
				});
			}, this));

			$('window').resize();
		}
	}]);

	return MainSlider;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.Slider = (function () {
	function Slider(root, options) {
		_classCallCheck(this, Slider);

		this.root = root;

		this.options = {
			scrollStep: 300,
			duration: 300,
			rigidness: 40,
			damping: 0.9,
			from: 0,
			to: 0,
			targetLimits: [0, 1],
			positionLimits: [0, 1]
		};

		_.assign(this.options, options);

		this.currentOffset = 0;
		this.previousOffset = 0;

		if (!this.root.data('active-slider')) {
			this._cacheNodes();
			this._createComponents();
			this._bindEvents();
			this._ready();
		}
	}

	_createClass(Slider, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				inner: this.root.find('.js-inner'),
				itemsWrapper: this.root.find('.js-items'),
				items: this.root.find('.js-item'),
				backwardButton: this.root.find('.js-backward-button'),
				forwardButton: this.root.find('.js-forward-button'),
				progressWrapper: this.root.find('.js-progress-wrapper'),
				progress: this.root.find('.js-progress')
			};
		}
	}, {
		key: '_createComponents',
		value: function _createComponents() {
			var self = this;
			var roundFactor = 10000;

			this.spring = new $$.Simulation.Spring({
				rigidness: this.options.rigidness,
				damping: this.options.damping,
				position: this.options.from,
				target: this.options.to,
				positionLimits: this.options.targetLimits,
				step: function step() {
					var roundPosition = Math.round(this.position() * roundFactor) / roundFactor;
					var roundTarget = Math.round(this.target() * roundFactor) / roundFactor;

					if (roundPosition === roundTarget && !self.force) {
						return;
					}

					self.force = false;

					var position = Math.round(this.position() * roundFactor) / roundFactor;

					self.nodes.progress.css({
						marginLeft: Math.round(position * self.maxScrollBarPosition)
					});

					self.nodes.itemsWrapper.css({ marginLeft: -1 * position * self.rightLimit });
				}
			});
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.backwardButton.on('click', function () {
				_this._goTo(-_this.scrollStep);
			});

			this.nodes.forwardButton.on('click', function () {
				_this._goTo(_this.scrollStep);
			});

			this.nodes.progress.on('drag', { relative: true }, function (event, data) {
				_this._scrollTo(data.offsetX - data.originalX + _this.previousOffset);
				_this.root.addClass('active');
				_this.nodes.progressWrapper.addClass('hover');
			});

			this.nodes.progress.on('dragend', function () {
				_this.previousOffset = _this.currentOffset;
				_this.root.removeClass('active');
				_this.nodes.progressWrapper.removeClass('hover');
			});

			$$.window.on('resize', function () {
				_this._calculateScrollWidth();
				_this._resizeSlider();
			});

			this.root.on('click', '.js-open-image', function (event) {
				"use strict";
				var item = $(event.currentTarget);
				var popup = $('body').find('.g-popup-wrap');

				if ($('body').find('.g-popup-wrap').length) {
					popup.remove();
				}

				_this._createPopup('<img src="' + item.data('original') + '"');

				event.preventDefault();
			});

			$('body').on('click', '.g-popup-wrap .js-close, .g-popup-wrap .g-body-overlay', function (event) {
				"use strict";
				var item = $(event.currentTarget);
				event.preventDefault();

				item.parents('.g-popup-wrap').fadeOut(200, function () {
					$(this).remove();
				});
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			this._calculateScrollWidth();

			this.scrollStep = this.options.scrollStep;

			this.sliderWidth = this.nodes.inner.width();

			if (this.sliderWidth !== 0) {
				this.root.data('active-slider', true);
			}

			this.nodes.forwardButton.show();
			this.nodes.backwardButton.show();
		}
	}, {
		key: '_createPopup',
		value: function _createPopup(content) {
			"use strict";
			$('body').append('\n\t\t<div class="g-popup-wrap">\n\t\t<div class="g-body-overlay"></div>\n\t\t\t<div class="g-popup-inner">\n\t\t\t\t<a class="close js-close"><span class="g-icon g-icon-close"></span></a>\n\t\t\t\t<div class="content">\n\t\t\t\t\t' + content + '\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t');
		}
	}, {
		key: '_resizeSlider',
		value: function _resizeSlider() {
			var sliderWidth = this.nodes.inner.width();

			this._scrollTo(this.currentOffset - sliderWidth + this.sliderWidth);
			this.sliderWidth = sliderWidth;
		}
	}, {
		key: '_calculateScrollWidth',
		value: function _calculateScrollWidth() {
			var containerWidth = this.nodes.itemsWrapper.width();
			var progressBarWidth = 100 * this.root.width() / containerWidth;

			this.nodes.progress.css({ width: progressBarWidth + '%' });
			this.rightLimit = containerWidth - this.root.width();

			if (progressBarWidth < 100) {
				this.maxScrollBarPosition = this.nodes.inner.width() - this.nodes.progress.width();

				this.nodes.inner.removeClass('border-bottom');
				this.nodes.forwardButton.removeClass('hidden');
				this.nodes.backwardButton.removeClass('hidden');
				this.nodes.progressWrapper.removeClass('hidden');
			} else {
				this.maxScrollBarPosition = this.nodes.inner.width() - this.nodes.progress.width();
				this.nodes.inner.addClass('border-bottom');
				this.nodes.forwardButton.addClass('hidden');
				this.nodes.backwardButton.addClass('hidden');
				this.nodes.progressWrapper.addClass('hidden');
			}
		}
	}, {
		key: '_scrollTo',
		value: function _scrollTo(offset) {
			var ratio = this.options.targetLimits[1] / this.maxScrollBarPosition;
			var position = offset * ratio;

			if (position < -1 || offset < 0) {
				this.previousOffset = this.currentOffset;
				return;
			}

			position = $$.clamp(position, 0, 1);
			this.spring.target(position);
			this.currentOffset = offset;
		}
	}, {
		key: '_goTo',
		value: function _goTo(step) {
			var offset = step + this.currentOffset;

			if (offset < 0) {
				offset = 0;
			} else if (offset > this.rightLimit) {
				offset = this.rightLimit;
			}

			this._scrollTo(offset);
		}
	}]);

	return Slider;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.Tabs = (function () {
	function Tabs(root) {
		_classCallCheck(this, Tabs);

		this.root = root;
		this.isAnimating = false;
		this.tabsWidth = this.root.width();
		this.currentTab = 0;

		this.options = {
			duration: 300,
			easing: 'swing',
			emptySpace: 30
		};

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_createClass(Tabs, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				tabs: this.root.find('.js-tab'),
				tabContents: this.root.find('.js-tab-content'),
				contentWrapper: this.root.find('.js-content-wrapper'),
				outer: this.root.find('.js-outer')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.nodes.tabs.on('click', function (event) {
				var tab = $(event.currentTarget);

				if (tab.hasClass('current')) {
					_this._recheckHeight(tab.index());

					return false;
				}

				_this._goTo(tab.index());

				return false;
			});
		}
	}, {
		key: '_ready',
		value: function _ready() {
			var height = this.nodes.tabContents.first().height();

			this.nodes.outer.css({ height: height + this.options.emptySpace });
		}
	}, {
		key: '_goTo',
		value: function _goTo(position) {
			var _this2 = this;

			if (this.isAnimating) {
				return;
			}

			var isNext = position > this.currentTab;

			this.nodes.tabContents.each(function (number, tabElement) {
				var tab = $(tabElement);

				if (number === position || number === _this2.currentTab) {
					tab.show();
				} else {
					tab.hide();
				}
			});

			this.isAnimating = true;
			this.nodes.tabContents.eq(this.currentTab).removeClass('show');
			this.nodes.tabs.eq(this.currentTab).removeClass('current').removeClass('none').addClass('dashed');

			this.currentTab = position;

			this.nodes.tabContents.eq(this.currentTab).addClass('show');
			this.nodes.tabs.eq(this.currentTab).addClass('current').addClass('none').removeClass('dashed');

			if (isNext) {
				this.nodes.contentWrapper.css({ marginLeft: 0 });
			} else {
				this.nodes.contentWrapper.css({ marginLeft: -this.tabsWidth });
			}

			_.defer(function () {
				_this2._recheckHeight(position);
			});

			this.nodes.contentWrapper.animate({
				marginLeft: isNext ? -this.tabsWidth : 0
			}, this.options.duration, this.options.easing, function () {
				_this2.isAnimating = false;
			});
		}
	}, {
		key: '_recheckHeight',
		value: function _recheckHeight(position) {
			var tabHeight = this.nodes.tabContents.eq(position).height();

			this.nodes.outer.animate({
				height: tabHeight + this.options.emptySpace
			}, this.options.duration, this.options.easing);
		}
	}]);

	return Tabs;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

$$.VideoBlock = (function () {
	function VideoBlock(root) {
		_classCallCheck(this, VideoBlock);

		this.root = root;

		this._cacheNodes();
		this._bindEvents();
	}

	_createClass(VideoBlock, [{
		key: '_cacheNodes',
		value: function _cacheNodes() {
			this.nodes = {
				inner: this.root.find('.js-inner')
			};
		}
	}, {
		key: '_bindEvents',
		value: function _bindEvents() {
			var _this = this;

			this.root.on('click', function () {
				var videoType = _this.root.data('videoType');
				var videoId = _this.root.data('videoId');
				var width = _this.root.width();
				var height = _this.root.height();
				var template = $$.makeVideoPlayerHtml(videoType, videoId, width, height);

				_this.nodes.inner.html(template);
			});
		}
	}]);

	return VideoBlock;
})();
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $$ = $$ || {};

$$.YandexMetrika = (function () {
	function YandexMetrika(counter) {
		_classCallCheck(this, YandexMetrika);

		if (!counter) {
			//console.log('ya error');
		} else {
				this.counter = counter;
			}
	}

	_createClass(YandexMetrika, [{
		key: "reachGoal",
		value: function reachGoal(goal) {
			if (this.counter) {
				this.counter.reachGoal(goal);
			}
		}
	}]);

	return YandexMetrika;
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $$ = $$ || {};

var Application = (function () {
	function Application() {
		_classCallCheck(this, Application);

		this._initMainSlider();
		this.initSliderCards();
		this.initProductCards();
		this._initHeader();
		this._initAuth();
		this._initPageNotFound();
		this._initContentSlider();
		this.initFeedbackSliderCards();
		this._initVideoBlocks();
		this._initTabs();
		this._initCart();
		this._initDelivery();
		this._initProfilePage();
		this._initRegistrationPage();
		this._initRegistrationEvent();
		this._initContactsMap();
		this._initCardPage();
		this._initProductCard();
		this._initCatalogMenu();
		this._initFormTabs();
		this._initPartnerForm();
		this._initCollapseBlocks();
		this._initPopup();
		this._initOpenPopup();
		this._initFixedHeader();
		this._initAnchors();
		this._initDeliveryPopup();
		this._initScrollBottomRegistration();

		this._initScrollList();

		this._initAjaxSearch();

		this.initLearnHowToOrder();

		this._mainScripts();

		this._fixIeFormButtons();
	}

	_createClass(Application, [{
		key: '_initMainSlider',
		value: function _initMainSlider() {
			$('.js-main-slider').each(function () {
				new $$.BannerSlider($(this));
			});
		}
	}, {
		key: 'initSliderCards',
		value: function initSliderCards() {
			$('.js-slider').each(function (index, event) {
				if (!$(event).data('init-slider')) {
					$(event).data('init-slider', true);

					new $$.Slider($(this));
				}
			});
		}
	}, {
		key: 'initProductCards',
		value: function initProductCards() {
			$('.js-not-slider').each(function (index, event) {
				if (!$(event).data('init-not-slider')) {
					$(event).data('init-not-slider', true);

					new $$.ProductCards($(this));
				}
			});
		}
	}, {
		key: '_initHeader',
		value: function _initHeader() {
			$('.js-header-wrapper').each(function () {
				new $$.Header($(this));
			});
		}
	}, {
		key: '_initAuth',
		value: function _initAuth() {
			$('.js-auth').each(function () {
				new $$.Auth($(this));
			});
		}
	}, {
		key: '_initPageNotFound',
		value: function _initPageNotFound() {
			$('.js-page-not-found').each(function () {
				new $$.PageNotFound($(this));
			});
		}
	}, {
		key: '_initContentSlider',
		value: function _initContentSlider() {
			$('.js-content-slider').each(function () {
				new $$.ContentSlider($(this));
			});
		}
	}, {
		key: 'initFeedbackSliderCards',
		value: function initFeedbackSliderCards() {
			$('.js-feedback-slider').each(function (index, event) {
				if (!$(event).data('init-feedback-slider')) {
					$(event).data('init-feedback-slider', true);

					new $$.FeedbackSlider($(this));
				}
			});
		}
	}, {
		key: '_initVideoBlocks',
		value: function _initVideoBlocks() {
			$('.js-video-block').each(function () {
				new $$.VideoBlock($(this));
			});
		}
	}, {
		key: '_initTabs',
		value: function _initTabs() {
			$('.js-tabs-handler').each(function () {
				new $$.Tabs($(this));
			});
		}
	}, {
		key: '_initCart',
		value: function _initCart() {
			$('.js-cart').each(function () {
				new $$.Cart($(this));
			});
		}
	}, {
		key: '_initDelivery',
		value: function _initDelivery() {
			$('.js-delivery').each(function () {
				new $$.Delivery($(this));
			});
		}
	}, {
		key: '_initProfilePage',
		value: function _initProfilePage() {
			$('.js-profile-page').each(function () {
				new $$.ProfilePage($(this));
			});
		}
	}, {
		key: '_initRegistrationPage',
		value: function _initRegistrationPage() {
			$('.js-registration-page').each(function () {
				new $$.RegistrationPage($(this));
			});
		}
	}, {
		key: '_initRegistrationEvent',
		value: function _initRegistrationEvent() {
			$('.js-registration-event-form').each(function () {
				new $$.RegistrationEvent($(this));
			});
		}
	}, {
		key: '_initContactsMap',
		value: function _initContactsMap() {
			$('.js-contacts-map-wrapper').each(function () {
				new $$.ContactsMap($(this));
			});
		}
	}, {
		key: '_initCardPage',
		value: function _initCardPage() {
			$('.js-card-page').each(function () {
				new $$.CardPage($(this));
			});
		}
	}, {
		key: '_initProductCard',
		value: function _initProductCard() {
			$('.js-aside-card').each(function () {
				new $$.ProductCard($(this));
			});
		}
	}, {
		key: '_initCatalogMenu',
		value: function _initCatalogMenu() {
			$('.js-catalog-menu-wrapper').each(function () {
				new $$.CatalogMenu($(this));
			});
		}
	}, {
		key: '_initCollapseBlocks',
		value: function _initCollapseBlocks() {
			$('.js-collapse-blocks').each(function () {
				new $$.CollapseBlocks($(this));
			});
		}
	}, {
		key: '_initScrollList',
		value: function _initScrollList() {
			$('.js-scroll-list').each(function () {
				new $$.ScrollList($(this));
			});
		}

		// Форма расчет монтажа
	}, {
		key: '_initFormTabs',
		value: function _initFormTabs() {
			$('.js-form-tabs').each(function () {
				new $$.FormTabs($(this));
			});
		}
	}, {
		key: '_initPartnerForm',
		value: function _initPartnerForm() {
			$('.js-partner-form').each(function () {
				new $$.PartnerForm($(this));
			});
		}
	}, {
		key: '_initAjaxSearch',
		value: function _initAjaxSearch() {
			$('.js-search-wrapper').each(function () {
				new $$.AjaxSearch($(this));
			});
		}
	}, {
		key: '_initPopup',
		value: function _initPopup() {
			$('.js-popup').each(function () {
				$$.Popup = new $$.Popup($(this));
			});
		}
	}, {
		key: '_initOpenPopup',
		value: function _initOpenPopup() {
			$('.js-open-popup').each(function () {
				new $$.OpenPopup($(this));
			});
		}
	}, {
		key: '_initFixedHeader',
		value: function _initFixedHeader() {
			$('.js-fixed-header').each(function () {
				new $$.FixedHeader($(this));
			});
		}
	}, {
		key: '_initAnchors',
		value: function _initAnchors() {
			$('.js-anchors').each(function () {
				new $$.Anchors($(this));
			});
		}
	}, {
		key: '_initDeliveryPopup',
		value: function _initDeliveryPopup() {
			$('.js-delivery-popup').each(function () {
				new $$.DeliveryPopup($(this));
			});
		}
	}, {
		key: '_initScrollBottomRegistration',
		value: function _initScrollBottomRegistration() {
			$('.js-scroll-bottom-registration').each(function () {
				new $$.ScrollBottomRegistration($(this));
			});
		}
	}, {
		key: 'initLearnHowToOrder',
		value: function initLearnHowToOrder() {
			$('.cards-wrapper .js-feedback').each(function (index, event) {
				if (!$(event).data('init-cards-feedback')) {
					$(event).data('init-cards-feedback', true);

					new $$.LearnHowToOrder($(this));
				}
			});
		}
	}, {
		key: '_mainScripts',
		value: function _mainScripts() {
			"use strict";

			$('.social-likes').each(function () {
				var data = $(this).data();
				$(this).socialLikes({
					url: location.origin,
					title: data.title,
					counters: false,
					singleTitle: ''
				});
			});

			var messages = $('.js-messages');

			var messagesData = messages.data();

			_.each(messagesData, function (value, key) {
				if (_.isBoolean(value)) {
					if (value) {
						$$.Noty[key]();
					}
				} else {
					var val = value.split('-');
					if (val[0] === 'true') {
						$$.Noty[key](val[1], val[2]);
					}
				}
			});

			$('select').styler();

			$$.initCountGoods();

			$('.jq-selectbox ul').each(function () {
				"use strict";
				$(this).niceScroll({
					cursorcolor: '#0c64d4',
					cursoropacitymin: 1,
					cursorwidth: 10,
					cursorborder: 'none',
					cursorborderradius: 0,
					cursorfixedheight: 90
				});
			});

			var phoneMask = new Inputmask("8 (999) 999-99-99");

			$('.js-phone-input').each(function () {
				"use strict";

				phoneMask.mask($(this).get(0));
			});

			$('.js-not-found-search-input').each(function () {
				$(this).on('focus', function () {
					$(this).parent().addClass('focus');
				});

				$(this).on('blur', function () {
					$(this).parent().removeClass('focus');
				});
			});

			$('.js-product-cards-tabs').each(function () {
				var tabs = $(this);
				var tab = tabs.find('.js-slider');
				var tabLink = tabs.find('.js-tab-link');

				tab.addClass('hidden');
				tab.first().removeClass('hidden');

				tabLink.on('click', function (event) {
					event.preventDefault();
					var link = $(this);
					tabLink.removeClass('current');
					link.addClass('current');

					tab.removeClass('show');
					tab.addClass('hidden');

					tab.eq(link.index()).removeClass('hidden').addClass('show');

					new $$.Slider(tab.eq(link));
				});
			});

			$('.js-compare-page').each(function () {
				var item = $(this);

				var compareList = item.find('.js-compare-header-list a');
				var products = item.find('.js-products');

				compareList.on('click', function (event) {
					event.preventDefault();
					var compareLink = $(event.currentTarget);
					var index = compareLink.index();

					compareLink.siblings().removeClass('current');
					compareLink.siblings().addClass('dotted');
					compareLink.removeClass('dotted');
					compareLink.removeClass('current');

					products.removeClass('active');
					products.eq(index).addClass('active');

					new $$.Slider(products.eq(index).find('.js-slider'));
				});
			});

			$('.js-form-back').each(function () {
				$(this).validate({
					submitHandler: function submitHandler(form) {
						form = $(form);

						$.ajax({
							url: form.attr('action'),
							method: form.attr('method'),
							data: form.serialize(),
							success: function success(response) {
								response = $.parseJSON(response);

								if (response.success) {
									$$.Noty['successMessage'](response.success);
								} else {
									_.each(response.errors, function (value, key) {
										var input = form.find('input[name="' + key + '"]').addClass('error');
										var error = $('<label class="error">' + value + '</label>');

										error.insertAfter(input);
									});
								}
							}
						});
					}
				});
			});

			$('.js-price-search').each(function () {
				var prices = $('.b-price-page .g-table .col-xs-5 a .text');

				$(this).on('input', function () {
					var input = $(this);

					var searchData = input.val().toLowerCase();

					if (searchData) {
						prices.parents('.row.body').removeClass('hidden');

						prices.filter(function (index, element) {
							var priceItem = $(element);
							var priceItemName = priceItem.text().toLowerCase();

							var isValidStart = !_.startsWith(priceItemName, searchData);

							return isValidStart;
						}).parents('.row.body').addClass('hidden');
					} else {
						prices.parents('.row.body').removeClass('hidden');
					}
				});
			});

			$('.js-partner-price').each(function () {
				$(this).on('click', function () {
					$('html,body').animate({
						scrollTop: $('.js-partner-form').offset().top
					});
				});
			});

			$('.js-open-feedback').on('click', function (event) {
				event.preventDefault();

				$$.body.trigger('openfeedback');
			});
		}
	}, {
		key: '_fixIeFormButtons',
		value: function _fixIeFormButtons() {
			// detect if browser supports this
			var sampleElement = $('[form]').get(0);
			var isIE11 = !window.ActiveXObject && "ActiveXObject" in window;

			if (sampleElement && window.HTMLFormElement && isIE11) {
				//&& sampleElement.form instanceof HTMLFormElement
				$.fn.appendField = function (data) {
					// for form only
					if (!this.is('form')) return;

					// wrap data
					if (!$.isArray(data) && data.name && data.value) {
						data = [data];
					}

					var $form = this;

					// attach new params
					$.each(data, function (i, item) {
						$('<input/>').attr('type', 'hidden').attr('name', item.name).val(item.value).appendTo($form);
					});

					return $form;
				};

				/**
     * Find all input fields with form attribute point to jQuery object
     *
     */
				$('form[id]').each(function () {
					var form = this,
					    $form = $(form),
					    $fields = $('[form=' + $form.attr('id') + ']');

					$fields.filter('.g-button').click(function () {
						$(form).appendField({ name: this.name, value: this.value }).submit();
					});
				});
			}
		}
	}, {
		key: 'noty',
		value: function noty(root) {
			var messages = root.find('.js-messages');

			var messagesData = messages.data();

			_.each(messagesData, function (value, key) {
				if (_.isBoolean(value)) {
					if (value) {
						$$.Noty[key]();
					}
				} else {
					var val = value.split('-');
					if (val[0] === 'true') {
						$$.Noty[key](val[1], val[2]);
					}
				}
			});
		}
	}]);

	return Application;
})();

$(function () {
	$$.window = $(window);
	$$.body = $(document.body);
	$$.windowWidth = $$.window.width();
	$$.windowHeight = $$.window.height();
	$$.initCountGoods = function () {
		"use strict";
		var Cart = $('.js-cart-small');

		var changeCount = {
			minus: function minus(count) {
				"use strict";

				return count <= 1 ? 1 : --count;
			},

			plus: function plus(count) {
				"use strict";

				return ++count;
			}
		};

		$('.js-count-goods').each(function () {
			var amount = $(this);

			if (amount.data('countGoodsEnabled')) {
				return;
			}

			amount.siblings('.js-add-to-cart').data('count', 1);

			var inputVal = amount.find('input').val();

			if (parseInt(inputVal) === 1) {
				amount.find('.minus').addClass('disable');
			} else {
				amount.find('.minus').removeClass('disable');
			}

			amount.on('click', 'a', function (event) {
				"use strict";
				event.preventDefault();

				var item = $(event.currentTarget);
				var input = item.siblings('input');
				var className = item.attr('class').split(' ')[0];

				input.val(changeCount[className](input.val()));

				amount.siblings('.js-add-to-cart').data('count', parseInt(input.val()));

				amount.find('input').trigger('change');
			});

			amount.on('change', 'input', function (event) {
				var input = $(event.currentTarget);
				var inputValue = parseInt(input.val());
				var minValue = parseInt(input.attr('min'));
				var maxValue = parseInt(input.attr('max'));

				if (inputValue < minValue) {
					input.val(minValue);
				}

				if (inputValue > maxValue) {
					input.val(maxValue);
				}

				if (amount.parents('.js-cart').length) {
					if (!amount.find('.minus').hasClass('disable')) {
						$.ajax({
							url: $$.Config.updateCartUrl,
							method: 'POST',
							data: {
								id: amount.parents('.js-card').data('id'),
								count: parseInt(input.val())
							},
							success: function success(response) {
								response = $.parseJSON(response);

								if (response.SUM) {
									amount.siblings('.price-wrapper').find('.price').text(response.SUM);
									Cart.find('.price').text(response.SUM_ALL);
									$('.js-sum-all').text(response.SUM_ALL);
									Cart.find('.count').text(response.COUNT);
								}
							},
							error: function error(_error) {
								$$.Noty['errorMessage'](_error.status + ' - ' + _error.statusText);
							}
						});
					}
				}

				if (parseInt(input.val()) === 1) {
					amount.find('.minus').addClass('disable');
				} else {
					amount.find('.minus').removeClass('disable');
				}
			});

			amount.on('keyup', 'input', function (event) {
				"use strict";

				var item = $(event.currentTarget);

				if (parseInt(item.val()) < 1) {
					item.val(1);
				}

				if (isNaN(parseInt(item.val()))) {
					item.val(1);
				}

				item.val(parseInt(item.val()));

				amount.siblings('.js-add-to-cart').data('count', parseInt(item.val()));
			});

			amount.siblings('.js-add-to-cart').on('click', function (event) {
				"use strict";

				event.preventDefault();

				var item = $(event.currentTarget);

				$.ajax({
					url: $$.Config.addCartUrl,
					method: 'POST',
					data: item.data(),
					success: function success(response) {
						response = $.parseJSON(response);

						$$.Noty['successMessage']('Добавлен товар - ' + response.NAME);

						if (response.SUM_ALL) {
							Cart.find('.money .price').text(response.SUM_ALL);
							Cart.find('.money .count').text(response.COUNT);

							if (Cart.find('.money').hasClass('hidden')) {
								Cart.find('.empty-cart').addClass('hidden');
								Cart.find('.money').removeClass('hidden');
							}
						}
					},
					error: function error(_error2) {
						$$.Noty['errorMessage'](_error2.status + ' - ' + _error2.statusText);
					}
				});
			});
		});
	};

	$$.application = new Application();

	$$.ESCAPE_KEY_CODE = 27;
	$('.p-content-wrapper').css({ minHeight: $$.window.height() - 60 });

	$$.window.on('resize', function () {
		$$.windowWidth = $$.window.width();
		$$.windowHeight = $$.window.height();
		$('.p-content-wrapper').css({ minHeight: $$.window.height() - 60 });
	});
});

$(window).load(initAnalytics);